/**
 * Created by Gustavo on 08/06/2016.
 */

import {Injectable}   from '@angular/core';
import { Http, Response } from '@angular/http';

declare var Swal : any;

@Injectable()
export class TranslationService {
 public mylanguage='pt';
 public pt={
  'ENTER':'Entrar',
  'ERROR':'Erro',
  'FAIL':'Falha',
  'NO':' Não',
  'REGISTER':'Cadastrar',
  'SUCCESS':'Sucesso',
  'TALENT':'Talento',
  'UNLOG':'Deslogar',
  'WAIT':'Aguarde',
  'WALLET':'Carteira',
  'YES':' Sim',
  'SEARCH':'Busca',
  'SAVE':' Salvar',


  'CHAT':'Chat',
  'ATTENTION':'Chamar atenção',
  'VIDEOCALL':'Chamada por vídeo',
  'TELEPORT':'Teleportar para mim',
  'KICK':'Chutar da sala',
  'BAN':'Banir da sala',
  'TESTVIDEO':'Testar Video',
  'DOREGISTER':'Se cadastrar',
  'CHANGEAVATAR':'Mudar Avatar',
  'TRADE':'Negociar',
  'TRANSFER':'Transferir',
  'CANCEL':'Cancelar',
  'CAMERA':'Camera',
  'GOTO':'Ir para',
  'SCHEDULE':'Agenda',
  'NOTIFICATIONS':'Notificações',
  'ADDNOTIFICATIONS':'Criar notificações',
  'TASKS':'Tarefas',


  'USER_INTERACTION_0':'Idade',
  'USER_INTERACTION_1':'Bio',
  'USER_INTERACTION_2':'Pedir Contato',
  'USER_INTERACTION_3':'Você deseja pedir contato de ',
  'USER_INTERACTION_4':' para adicionar na sua lista de contatos? Se aceitar você receberá pontos em comunicação. Você pode pedir a qualquer momento. Deseja pedir?',
  'USER_INTERACTION_5':' pediu seu contato. Você aceita dar seu contato com acesso a seu email e telefone? Se aceitar você poderá receber pontos comunicação.',

  'EVENT_COMPONENT_0':'Uso em celular',
  'EVENT_COMPONENT_1':'Para melhorar seu uso, pedimos que você deixe o site em fullscreen e o celular na horizontal. E não se esqueça de habilitar o audio e microfone.',
  'EVENT_COMPONENT_2':'Dúvidas',
  'EVENT_COMPONENT_3':'Está com problemas? Podemos te enviar para a recepção onde nosso time vai tentar resolver ou esclarecer suas dúvidas. Você aceita?',
  'EVENT_COMPONENT_4':'Está com problemas? Podemos te enviar para a tela inicial de ajustes de câmera, audio e cadastramento para que você tente resolvê-las. Você aceita?',
  'EVENT_COMPONENT_5':'Pedido de contato',
  'EVENT_COMPONENT_6':'Pedido de ir para site',
  'EVENT_COMPONENT_7':' está pedindo que você vá para um outro site. Você aceita?',
  'EVENT_COMPONENT_8':'Pedido de Fix na Videoconferência',
  'EVENT_COMPONENT_9':' está pedindo que você atualize sua videoconferência para resolver um erro. Você aceita?',
  'EVENT_COMPONENT_10':"Mapa",
  'EVENT_COMPONENT_11':"Esse objeto está estático mas você é o dono e portanto pode torná-lo dinâmico. Você quer que ele fique dinâmico? ",
  'EVENT_COMPONENT_12':'Objeto dinamizado você agora pode movê-lo.',
  'EVENT_COMPONENT_13':"Esse objeto está estático e você não é o dono. Por isso você não pode editá-lo ",
  'EVENT_COMPONENT_14':'Você está distante deste objeto',
  'EVENT_COMPONENT_15':'Se aproxime do objeto para olhar seu conteúdo',
  'EVENT_COMPONENT_16':'Usuário deslogado',
  'EVENT_COMPONENT_17':'Você precisa se logar pra usar containers',
  'EVENT_COMPONENT_18':'Fix na Videoconferência',
  'EVENT_COMPONENT_19':'Vamos abrir os painéis de controle de audio na videoconferência. Verifique se o microfone e as saídas de audio estão bem configuradas.',
  'EVENT_COMPONENT_20':'Ir para o Mapa',
  'EVENT_COMPONENT_21':'Você quer ir para o mapa?',
  'EVENT_COMPONENT_22':'Área sem mapa',
  'EVENT_COMPONENT_23':'Essa área não possui acesso ao mapa habilitado.',
  'EVENT_COMPONENT_24':'Você não tem a chave',
  'EVENT_COMPONENT_25':'Procure uma pessoa que possa te dar a chave para trancar a porta.',
  'EVENT_COMPONENT_26':'Reunião local',
  'EVENT_COMPONENT_27':'Você aceitar ir para conferência local em: ',
  'EVENT_COMPONENT_28':'Videoconferência local',
  'EVENT_COMPONENT_29':'O seu audio está <b>saindo</b> do audio local para uma videoconferência privada em ',
  'EVENT_COMPONENT_30':'.<br><br> Você <b>apenas</b> ouvirá pessoas que também <b>entrarem</b> nessa videoconferência.<br><br> Para voltar ao modo de audio por proximidade clique no icone da porta no topo da tela.',
  'EVENT_COMPONENT_40':'Link para uma nova janela',
  'EVENT_COMPONENT_41':'Você será direcionado para uma nova página. Você aceita?',
  'EVENT_COMPONENT_42':'Visualizar ',
  'EVENT_COMPONENT_43':'Vamos abrir uma nova página de internet em outra aba do seu navegador com as informações do link ',
  'EVENT_COMPONENT_44':'. Você aceita?',
  'EVENT_COMPONENT_45':'Você está distante deste objeto',
  'EVENT_COMPONENT_46':'Se aproxime do objeto para interagir',
  'EVENT_COMPONENT_47':"Sem Permissão",
  'EVENT_COMPONENT_48':"Você não possui permissão para o painel de controle da sala.",
  'EVENT_COMPONENT_49':"Ver item compartilhado",
  'EVENT_COMPONENT_50':"Você deseja ver o item que acabou de compartilhar?",

  'AVATAR_COMPONENT_0':'Personalize Avatar',
  'AVATAR_COMPONENT_1':'Agora vamos personalizar seu avatar!',
  'AVATAR_COMPONENT_2':'Gênero',
  'AVATAR_COMPONENT_3':'Opções',
  'AVATAR_COMPONENT_4':'Pele',
  'AVATAR_COMPONENT_5':'Escolha sua cor',
  'AVATAR_COMPONENT_6':'Intensidade',
  'AVATAR_COMPONENT_7':'Cabelo',
  'AVATAR_COMPONENT_8':'Torço',
  'AVATAR_COMPONENT_9':'Pés',
  'AVATAR_COMPONENT_10':'Gênero Masculino',
  'AVATAR_COMPONENT_11':'Gênero Feminino',
  'AVATAR_COMPONENT_12': 'Cor de ',
  'AVATAR_COMPONENT_13': 'Perna',
  'AVATAR_COMPONENT_14': 'Avatares pré-fabricados',
  'AVATAR_COMPONENT_15':'Equipado',
  'AVATAR_COMPONENT_16': 'Imagem',
  'AVATAR_COMPONENT_17': 'Nome',
  'AVATAR_COMPONENT_18': 'Selecionar',
  'AVATAR_COMPONENT_19': 'Polo',
  'AVATAR_COMPONENT_20': 'Regata',
  'AVATAR_COMPONENT_21': 'Camiseta',
  'AVATAR_COMPONENT_22': 'Social',
  'AVATAR_COMPONENT_23': 'Bermuda',
  'AVATAR_COMPONENT_24': 'Calça',
  'AVATAR_COMPONENT_25': 'Cueca',
  'AVATAR_COMPONENT_26': 'Sapato',
  'AVATAR_COMPONENT_27': 'Chinela',
  'AVATAR_COMPONENT_28': 'Curto',
  'AVATAR_COMPONENT_29': 'Longo',
  'AVATAR_COMPONENT_30': 'Topete',
  'AVATAR_COMPONENT_31': 'Topetão',
  'AVATAR_COMPONENT_32': 'De lado',
  'AVATAR_COMPONENT_33': 'Franja',
  'AVATAR_COMPONENT_34': 'Afro',
  'AVATAR_COMPONENT_35': 'Calvo',
  'AVATAR_COMPONENT_36': 'Camiseta',
  'AVATAR_COMPONENT_37': 'Camiseta',
  'AVATAR_COMPONENT_38': 'Vestido',
  'AVATAR_COMPONENT_39': 'Maiô',
  'AVATAR_COMPONENT_40': 'Jeans',
  'AVATAR_COMPONENT_41': 'Calcinha',
  'AVATAR_COMPONENT_42': 'Botas',
  'AVATAR_COMPONENT_43': 'Botas longas',
  'AVATAR_COMPONENT_44': 'Criando Avatar',
  'AVATAR_COMPONENT_45': 'Seu avatar está sendo criado em diversas posições. Esse processo demora um pouco aguarde término com essa janela aberta nesta aba para garantir um avatar bem feito',
  'AVATAR_COMPONENT_46': 'Erro Criando Avatar',
  'AVATAR_COMPONENT_47': 'Tivemos de parar o processamento do seu avatar pois vocÊ ou fechou a janela ou mudou de aba. Por favor tente novamente e aguarde o fim do processamento.',
  'AVATAR_COMPONENT_48': 'Escolher Avatar',
  'AVATAR_COMPONENT_49': 'Você deseja usar esse avatar?',
  'AVATAR_COMPONENT_50': 'Pre-Montados',



  'CARD_COMPONENT_1':'Cartão de Crédito',
  'CARD_COMPONENT_2':'Nome conforme está no cartão',
  'CARD_COMPONENT_3':'Atualmente cada Livecoin custa R$0.10. Compra mínima de R$1,00 (10 livecoins). Quantos livecoins você deseja comprar?',
  'CARD_COMPONENT_4':'Escolha a quantidade abaixo',
  'CARD_COMPONENT_5':'Comprar',
  'CARD_COMPONENT_6':'Por favor preencha o nome conforme presente no cartão',
  'CARD_COMPONENT_7':'Por favor preencha o número do cartão.',
  'CARD_COMPONENT_8':'Por favor preencha o cvv do cartão.',
  'CARD_COMPONENT_9':'Por favor preencha a validade do cartão.',
  'CARD_COMPONENT_10':'O valor mínimo de compra é 10 livecoins, equivalente a 1 real.',
  'CARD_COMPONENT_11':'Sua compra está sendo processada. Aguarde.',
  'CARD_COMPONENT_12':'Seus livecoins foram comprados com sucesso e foram adicionados a sua wallet.',
  'CARD_COMPONENT_13':'Ocorreu uma falha ao processar o dinheiro em livecoin mas sua transação está gravada e você pode tentar novamente.',

  'CHECKVIDEO_COMPONENT_1':'Teste sua',
  'CHECKVIDEO_COMPONENT_2':'VIDEO CONFERÊNCIA',
  'CHECKVIDEO_COMPONENT_3':'Clique em ',
  'CHECKVIDEO_COMPONENT_4':'Permitir',
  'CHECKVIDEO_COMPONENT_5':' se o navegador pedir por acesso À CÂMERA E MICROFONE.',
  'CHECKVIDEO_COMPONENT_6':'Se você conseguir se ver ou ver o que você está gravando na câmera então ela está funcionando corretamente.',
  'CHECKVIDEO_COMPONENT_7':'Problemas na Câmera?',
  'CHECKVIDEO_COMPONENT_8':'Problemas no microfone?',
  'CHECKVIDEO_COMPONENT_9':'Problemas no seu áudio?',
  'CHECKVIDEO_COMPONENT_10':'Navegador incompatível?',
  'CHECKVIDEO_COMPONENT_11':'Cadastre-se',
  'CHECKVIDEO_COMPONENT_12':'Escolha seu avatar',
  'CHECKVIDEO_COMPONENT_13':'Assista o tutorial abaixo para resolver problemas relacionados à câmera',
  'CHECKVIDEO_COMPONENT_14':'Ainda está com problemas? Fale conosco pelo ',
  'CHECKVIDEO_COMPONENT_15':'Assista o tutorial abaixo para resolver problemas relacionados ao áudio',
  'CHECKVIDEO_COMPONENT_16':'Problema no microfone',
  'CHECKVIDEO_COMPONENT_17':'Detectamos erro no seu microfone. Estamos abrindo o sistema de ajuste para você configurar o microfone e o audio',
  'CHECKVIDEO_COMPONENT_18':"Problema na câmera",
  'CHECKVIDEO_COMPONENT_19':"Detectamos erro na sua câmera. Estamos abrindo o sistema de ajuste para você configurar o microfone e o audio",
  'CHECKVIDEO_COMPONENT_20':'Sua câmera está com problemas.',
  'CHECKVIDEO_COMPONENT_21':'Sugerimos que você resolva este problema apertando o botão de Problemas na Câmera. Caso você queira, clique em ENTRAR abaixo para falar por videoconferência com um de nossos recepcionistas para lhe ajudar.',
  'CHECKVIDEO_COMPONENT_22':'Seu audio está com problemas.',
  'CHECKVIDEO_COMPONENT_23':'Sugerimos que você resolva este problema apertando o botão de Problemas no seu audio. Caso você queira, clique em ENTRAR abaixo para falar por videoconferência com um de nossos recepcionistas para lhe ajudar.',
  'CHECKVIDEO_COMPONENT_24':'Sua fone está com problemas.',
  'CHECKVIDEO_COMPONENT_25':'Sugerimos que você resolva este problema apertando o botão de Problemas no Microfone. Caso você queira, clique em ENTRAR abaixo para falar por videoconferência com um de nossos recepcionistas para lhe ajudar.',
  'CHECKVIDEO_COMPONENT_26':'Descadastrado.',
  'CHECKVIDEO_COMPONENT_27':'Você está descadastrado. Clique em Cadastre-se para logar. Você também pode entrar deslogado clicando em entrar.',
  'CHECKVIDEO_COMPONENT_28':'Tudo OK!',
  'CHECKVIDEO_COMPONENT_29':'Está tudo pronto para você entrar. Você pode clicar em ENTRAR e ir direto ao metaverso.',

  'PROFILE_COMPONENT_1':'Foto de Perfil',
  'PROFILE_COMPONENT_2':'Enviar carteira para email',
  'PROFILE_COMPONENT_3':'Comprar Livecoins',
  'PROFILE_COMPONENT_4':'Compras de Livecoins',
  'PROFILE_COMPONENT_5':'Digite seu email',
  'PROFILE_COMPONENT_6':'dd/mm/yyyy',
  'PROFILE_COMPONENT_7':'Fale sobre você',
  'PROFILE_COMPONENT_8':'Verifique seu email cadastrado no liveplanet. A chave da sua carteira estará lá..',
  'PROFILE_COMPONENT_9':'Ocorreu um erro ao enviar os dados da sua carteira para seu email.',
  'PROFILE_COMPONENT_10':'User é nulo',
  'PROFILE_COMPONENT_11':'Nome incompleto',
  'PROFILE_COMPONENT_12':'Email incompleto',
  'PROFILE_COMPONENT_13':'Telefone incompleto',
  'PROFILE_COMPONENT_14':'Data de Nascimento incompleto',
  'PROFILE_COMPONENT_15':'Sem foto',
  'PROFILE_COMPONENT_16':'Sem endereço',
  'PROFILE_COMPONENT_17':"Por favor preencha seu nome.",
  'PROFILE_COMPONENT_18':"Por favor preencha seu email.",
  'PROFILE_COMPONENT_19':"Dados de perfil salvos com sucesso.",
  'PROFILE_COMPONENT_20':'Vamos lá então!!',
  'PROFILE_COMPONENT_21':'Você está na lista dos participantes do evento. Quando o evento começar clique em ENTRAR NO EVENTO',

  'GAME_USERLOGIN_COMPONENT_1':'Entre com seu e-mail e senha',
  'GAME_USERLOGIN_COMPONENT_2':'Digite seu email',
  'GAME_USERLOGIN_COMPONENT_3':'Digite sua senha',
  'GAME_USERLOGIN_COMPONENT_4':'Esqueci minha senha',
  'GAME_USERLOGIN_COMPONENT_5':'Manter conectado',
  'GAME_USERLOGIN_COMPONENT_6':'Se cadastre e desfrute do metaverso do Live Planet',
  'GAME_USERLOGIN_COMPONENT_7':'Digite seu nome completo',
  'GAME_USERLOGIN_COMPONENT_8':'Selecione seu avatar',
  'GAME_USERLOGIN_COMPONENT_9':'Repita a senha',
  'GAME_USERLOGIN_COMPONENT_10':'Li e concordo com os termos e condições',
  'GAME_USERLOGIN_COMPONENT_11':"Por favor preenncha seu email para que possamos enviar um pedido de nova senha para você.",
  'GAME_USERLOGIN_COMPONENT_12':"Pedido de resetar senha enviado para seu email.",
  'GAME_USERLOGIN_COMPONENT_13':"Ocorreu um erro. Tem certeza que você se cadastrou? Vale tentar se cadastrar com esse email..",
  'GAME_USERLOGIN_COMPONENT_14':"Por favor preencha seu nome para que as pessoas te encontrem no liveparty.",
  'GAME_USERLOGIN_COMPONENT_15':"Por favor preencha seu email.",
  'GAME_USERLOGIN_COMPONENT_16':"Sua senha tem que ter 8 digitos",
  'GAME_USERLOGIN_COMPONENT_17':"Sua senha tem que ser confirmada",
  'GAME_USERLOGIN_COMPONENT_18':'Cadastro Feito',
  'GAME_USERLOGIN_COMPONENT_19':'Você está cadastrado. Que tal você agora definir seu avatar?',
  'GAME_USERLOGIN_COMPONENT_20':"Esse email já está cadastrado...tente novamente com outro email ou entre em contato conosco pelo contato@liveparty.com.br",
  'GAME_USERLOGIN_COMPONENT_21':"Login Feito",
  'GAME_USERLOGIN_COMPONENT_22':"Erro não identificado no cadastro do usuário. Avisar no nosso insta (@liveplanet_br) para que possamos lhe ajudar a finalizar o login.",
  'GAME_USERLOGIN_COMPONENT_23':"Senha incorreta para o email cadastrado",
  'GAME_USERLOGIN_COMPONENT_24':"Email não encontrado.",
  'GAME_USERLOGIN_COMPONENT_25':"Muitas tentativas...aguarde um tempo e tente novamente.",
  'GAME_USERLOGIN_COMPONENT_26':"Termos e condições de uso de dados.",

  'APPSCREEN_COMPONENT_1':'Usuários na Sala',
  'APPSCREEN_COMPONENT_2':'Salas',
  'APPSCREEN_COMPONENT_3':'Contato',
  'APPSCREEN_COMPONENT_4':'Galeria',
  'APPSCREEN_COMPONENT_5':'Salas Favoritas',
  'APPSCREEN_COMPONENT_6':'Notificar',
  'APPSCREEN_COMPONENT_7':'Editar',
  'CONTACT_SCREEN_COMPONENT_1':'Contatos na Sala',
  'CONTACT_SCREEN_COMPONENT_2':'Buscar contatos',
  'CONTACT_SCREEN_COMPONENT_3':"Chamada por vídeo",
  'CONTACT_SCREEN_COMPONENT_4':"Você deseja convidar esse usuário para falar contigo por videoconferência?",
  'CONTACT_SCREEN_COMPONENT_5':'Remover usuário da sala',
  'CONTACT_SCREEN_COMPONENT_6':'Você deseja remover ',
  'CONTACT_SCREEN_COMPONENT_7':'Banir usuário da sala',
  'CONTACT_SCREEN_COMPONENT_8':'Você deseja banir ',
  'CONTACT_SCREEN_COMPONENT_9':'? Ele vai ouvir um som para abrir o liveplanet',
  'CONTACT_SCREEN_COMPONENT_10':'Você não é um administrador da sala. Apenas administradores podem banir usuários.',
  'CONTACT_SCREEN_COMPONENT_11':'Você deseja chamar a atenção de ',
  'CONTACT_SCREEN_COMPONENT_12':'Chamar Atenção',
  'CONTACT_SCREEN_COMPONENT_13':' chamou sua atenção.',
  'CONTACT_SCREEN_COMPONENT_14':"TELEPORTE",
  'CONTACT_SCREEN_COMPONENT_15':"Você deseja convidar esse usuário a se teleportar para onde você está?",
  'CONTACT_SCREEN_COMPONENT_15a':"Você deseja se teleportar para a posição deste usuário?",
  'CONTACT_SCREEN_COMPONENT_16':'Convite enviado',
  'CONTACT_SCREEN_COMPONENT_17':' foi convidado para se teleportar para onde você se encontra. Aguarde resposta.',
  'CONTACT_SCREEN_COMPONENT_18':"Pedido de teleporte",
  'CONTACT_SCREEN_COMPONENT_19':" está te convidando para ir para o evento onde está. Você deseja ir?",
  'CONTACT_SCREEN_COMPONENT_20':' foi convidado para conversar contigo. Aguarde resposta.',
  'CONTACT_SCREEN_COMPONENT_21':"Pedido de videoconferência",
  'CONTACT_SCREEN_COMPONENT_22':" está te convidando para ir para conversar por videoconferência. Você aceita?",
  'CONTACT_SCREEN_COMPONENT_23':"Remoção",
  'CONTACT_SCREEN_COMPONENT_24':' te removeu da sala.',
  'CONTACT_SCREEN_COMPONENT_25':"Banimento",
  'CONTACT_SCREEN_COMPONENT_26':" te baniu da sala.",

  'FAVORITE_ROOM_SCREEN_1':'Buscar salas',
  'FAVORITE_ROOM_SCREEN_2':'Adicionar Sala',
  'FAVORITE_ROOM_SCREEN_3':'Ir para sala',
  'FAVORITE_ROOM_SCREEN_4':'Editar sala',
  'FAVORITE_ROOM_SCREEN_5':'Remover sala',
  'FAVORITE_ROOM_SCREEN_6':'Favoritado',
  'FAVORITE_ROOM_SCREEN_7':'Essa sala já foi favoritada',
  'FAVORITE_ROOM_SCREEN_8':"Na sala",
  'FAVORITE_ROOM_SCREEN_9':"Você já se encontra nessa sala.",
  'FAVORITE_ROOM_SCREEN_10':"Você deseja se teleportar para este local?",
  'FAVORITE_ROOM_SCREEN_11':'Remoção',
  'FAVORITE_ROOM_SCREEN_12':"Você deseja remover essa sala da sua lista de favoritos?",
  'FAVORITE_ROOM_SCREEN_13':'Editar Sala',
  'FAVORITE_ROOM_SCREEN_14':'Descreva o nome da sala para que seja fácil você identificá-la',
  'FAVORITE_ROOM_SCREEN_15': 'Sala cheia',
  'FAVORITE_ROOM_SCREEN_16':"Este local possui 70 usuários e está cheio. Aguarde alguém sair para você poder entrar.",
  'FAVORITE_ROOM_SCREEN_17':"Este local possui ",
  'FAVORITE_ROOM_SCREEN_18':" usuário de 70. Você pode entrar. ",

  'GALLERY_SCREEN_COMPONENT':'Carregar as imagens',

  'PROFILE_SCREEN_1':'Telefone',
  'PROFILE_SCREEN_2':'Aniversário',

  'CONTAINER_MODAL_0':'Mochila',
  'CONTAINER_MODAL_1':'Cabelo',
  'CONTAINER_MODAL_2':'Torço',
  'CONTAINER_MODAL_3':'mão esquerda',
  'CONTAINER_MODAL_4':'pés',
  'CONTAINER_MODAL_5':'pescoço',
  'CONTAINER_MODAL_6':'pernas',
  'CONTAINER_MODAL_7':'mão direita',
  'CONTAINER_MODAL_8':'dedos',
  'CONTAINER_MODAL_9':'pernas',
  'CONTAINER_MODAL_10':'Equipar',
  'CONTAINER_MODAL_11':'Equipando item...aguarde...',
  'CONTAINER_MODAL_12':'Desequipar',
  'CONTAINER_MODAL_13':'Você desequipar este item?',
  'CONTAINER_MODAL_14':'vazio',
  'CONTAINER_MODAL_15':'Item equipado',
  'CONTAINER_MODAL_16':'Desequipe este item para poder pintar',
  'CONTAINER_MODAL_17':'Transferir item',
  'CONTAINER_MODAL_18':'Você deseja transferir este item para o container?',
  'CONTAINER_MODAL_19':"Item não disponível",
  'CONTAINER_MODAL_20':"Este item apesar de seu, não se encontra na sua mochila. Verifique se ele não foi posto no chão ou em um vendedor.",
  'CONTAINER_MODAL_21':"Converter Token",
  'CONTAINER_MODAL_22':"Você tem direito a um item deste Token. Você deseja converter o token em um item do tipo ",
  'CONTAINER_MODAL_23':"Manipular item",
  'CONTAINER_MODAL_24':"Esse item não é compartilhável.",
  'CONTAINER_MODAL_25':'Convite para ver objeto',
  'CONTAINER_MODAL_26':' gostaria de compartilhar um link contigo. Você aceita?',
  'CONTAINER_MODAL_27':"Ver item compartilhado",
  'CONTAINER_MODAL_28':"Você deseja ver o item que acabou de compartilhar?",
  'CONTAINER_MODAL_29':"Este item está equipado. Remova ele para poder botar no chão.",
  'CONTAINER_MODAL_30':"Este item é super importante!! Você não quer perdê-lo.",
  'CONTAINER_MODAL_31':"Você está numa sala temporária e não pode deixar seu item no chão.",
  'CONTAINER_MODAL_32':'Para o chão',
  'CONTAINER_MODAL_33':'Você está removendo o item para o chão. Este item ao ser posto no chão sai da sua carteira e fica disponível para que outras pessoas o vejam e peguem. Você confirma que deseja por este item no chão?',
  'CONTAINER_MODAL_34':"Este item é um nft e não pode ser removido para o chão",
  'CONTAINER_MODAL_35':'Manipular Chave',
  'CONTAINER_MODAL_36':'Esta chave está conectada a sala de código:',
  'CONTAINER_MODAL_37':"Mudar nome",
  'CONTAINER_MODAL_38':"Digite um nome para esta chave",
  'CONTAINER_MODAL_39':'. O que você deseja fazer?',
  'CONTAINER_MODAL_40':'Local errado',
  'CONTAINER_MODAL_41':"Esse título de propriedade não é relacionado a essa sala, logo não pode ser utilizado aqui.",
  'CONTAINER_MODAL_42':'Objeto escrito',
  'CONTAINER_MODAL_43':'Este objeto já está escrito com um link para visualizar um site externo. Você deseja abrir e ler o site externo ou deseja apagar o conteúdo e escrever um novo site externo?',
  'CONTAINER_MODAL_44':'Ler',
  'CONTAINER_MODAL_45':"Escrever",
  'CONTAINER_MODAL_46':'Item equipável',
  'CONTAINER_MODAL_47':'Você deseja vestir este item?',
  'CONTAINER_MODAL_48':'Pintar objeto',
  'CONTAINER_MODAL_49':'Clique no objeto que você deseja pintar.',
  'CONTAINER_MODAL_50':"Digite um nome para este objeto",
  'CONTAINER_MODAL_51':"Digite o link onde ir quando clicar nesse objeto",
  'CONTAINER_MODAL_52':'Preencha um endereço URL válido',
  'CONTAINER_MODAL_53':"Clique no item para usar ou equipar",
  'CONTAINER_MODAL_54':"Clique no item para transferir para o mapa",
  'CONTAINER_MODAL_55':"Itens na no chão do mapa a coletar",
  'CONTAINER_MODAL_56':"Digite seu nome",
  'CONTAINER_MODAL_57':"Vazio",
  'CONTAINER_MODAL_58':"Trello",

  'EVENT_COMPONENT_1a':'Aumentar Zoom',
  'EVENT_COMPONENT_2a':'Diminuir Zoom',
  'EVENT_COMPONENT_3a':'Ferramentas',
  'EVENT_COMPONENT_4a':'Celular',
  'EVENT_COMPONENT_5a':'Audio',
  'EVENT_COMPONENT_6a':'Editar Avatar',
  'EVENT_COMPONENT_7a':'Compartilhar',
  'EVENT_COMPONENT_8a':'Anotações',
  'EVENT_COMPONENT_9a':'Sair',
  'EVENT_COMPONENT_10a':'Mídia / Transmissão',
  'EVENT_COMPONENT_11a':'Mapa',
  'EVENT_COMPONENT_12a':'Usuários Online',

  'TRANSITION_TITLE':'Transição',
  'TRANSITION_MESSAGE1':"Esse local possui ",
  'TRANSITION_MESSAGE2':"Você pode entrar."  ,

  'YOUTUBE_COMPONENT_1':"Clique e puxe ",
  'YOUTUBE_COMPONENT_2':"(devagar)",

  'TUTORIAL_COMPONENT_1':"Bem vindo ao metaverso!! Conversas são por audio - autorize uso do microfone.",
  'TUTORIAL_COMPONENT_2':"Headphones são bem vindos. Ajudam você a ouvir os outros",
  'TUTORIAL_COMPONENT_3':"Liveplanet é muito melhor se visto em widescreen.",
  'TUTORIAL_COMPONENT_4':"O cadastro não é obrigatório, mas é indicado para você ter um nome e avatar.",

  'PURCHASE_TERRAIN_MODAL_01': 'Comprar Terreno',
  'PURCHASE_TERRAIN_MODAL_02': 'Este terreno custa R$',
  'PURCHASE_TERRAIN_MODAL_03': ',00. Clique abaixo se você quer finalizar a transação e ter posse deste terreno do Liveplanet.',
  'PURCHASE_TERRAIN_MODAL_05': 'Você está descadastrado. Apenas usuários cadastrados podem realizar compras de terrenos',
  'PURCHASE_TERRAIN_MODAL_04': 'Comprar',
  'PURCHASE_TERRAIN_MODAL_06': 'Visitar',
  'PURCHASE_TERRAIN_MODAL_07': 'Você deseja visitar esse terreno?',
  'PURCHASE_TERRAIN_MODAL_09':'Agora que você comprou este terreno, ele está na sua mochila. Você será enviado para o seu terreno para que você possa editá-lo',
  'PURCHASE_TERRAIN_MODAL_10':'A sua compra foi efeituada mas a nossa rede está congestionada. Não se preocupe! Registramos sua compra e você pode tentar novamente obter o seu terreno clicando em OBTER TERRENO',

  'DOOR_BEAN_0':'Porta',
  'DOOR_BEAN_1':'Lotado',
  'DOOR_BEAN_2':'Este local possui ',
  'DOOR_BEAN_3':' usuários e está cheio. Aguarde alguém sair para você poder entrar.',
  'DOOR_BEAN_4':'trancar',
  'DOOR_BEAN_5':'destrancar',
  'DOOR_BEAN_6':'Você deseja utilizar a porta?',
  'DOOR_BEAN_7':'Entrar',
  'DOOR_BEAN_8':'Sair',
  'DOOR_BEAN_9':'Para manipular esse item você deve primeiro posicionar ela no chão de uma sala',
  'DOOR_BEAN_10':'A porta já está configurada. Você deseja reconfigurar ou usar?',
  'DOOR_BEAN_11':'Reconfigurar',
  'DOOR_BEAN_12':'A porta não está configurada. Você deseja configurar ou usar?',
  'DOOR_BEAN_13':'Configurar',
  'DOOR_BEAN_14':'Usar',
  'DOOR_BEAN_15':'Para qual função você usará essa porta?',
  'DOOR_BEAN_16':'Outra sala',
  'DOOR_BEAN_17':'Mesma sala',
  'DOOR_BEAN_18':'Configurar porta mesma sala',
  'DOOR_BEAN_19':'Sua porta está posicionada e na orientação certa?',
  'DOOR_BEAN_20':'Configuração de porta errada',
  'DOOR_BEAN_21':'Posicione e oriente a porta antes de fazer essa configuração',
  'DOOR_BEAN_30':'Porta atualizada',
  'DOOR_BEAN_31':'A porta foi atualizada com sucesso. Se no futuro movê-la precisará editar novamente',
  'DOOR_BEAN_32':'Para fora',
  'DOOR_BEAN_33':'Selecione a sala:',
  'DOOR_BEAN_34':'Porta Trancada',
  'DOOR_BEAN_35':'Esta porta está trancada e você não possui a chave. Se você comprou ingresso, clique no simbolo da empresa onde você comprou para obter a chave a partir do seu ingresso. Se você não comprou ingresso, busque um outro usuário na plataforma ou um NPC para liberar acesso.',
  'DOOR_BEAN_36':'Porta não configurada',
  'DOOR_BEAN_37':'Essa porta não está configurada. Configure ela antes de usar',

   'ITEM_EDIT_0':'Usar',
   'ITEM_EDIT_1':'Coletar',
   'ITEM_EDIT_2':'Estático',
   'ITEM_EDIT_3':'Girar',
   'ITEM_EDIT_4':'Textura 2D',
   'ITEM_EDIT_5':'Textura 3D',
   'ITEM_EDIT_6':'Ações',
   'ITEM_EDIT_7':'Posicionamento',
   'ITEM_EDIT_8':'Atualizar Textura',
   'ITEM_EDIT_9':'Apagar Textura',
   'ITEM_EDIT_10':'Atualizar Item',
   'ITEM_EDIT_11':'Selecione a ação do objeto',
   'ITEM_EDIT_12':'Defina a URL do site',
   'ITEM_EDIT_13':'Defina o vídeo',
   'ITEM_EDIT_14':'Texto',
   'ITEM_EDIT_15':'Defina o áudio do objeto',
   'ITEM_EDIT_16':'Defina a imagem a conectar neste objeto',
   'ITEM_EDIT_17':'Escolha o NPC',
   'ITEM_EDIT_18':'Editar Avatar',
   'ITEM_EDIT_19':'Escolha ação que ocorre próximo do objeto',
   'ITEM_EDIT_20':'Defina a URL do site que será embedado',
   'ITEM_EDIT_21':'Mutado',
   'ITEM_EDIT_22':'Defina a URL do site a ser exposto quando próximo ao item',
   'ITEM_EDIT_23':'Defina distância em X e Y de ativação',
   'ITEM_EDIT_24':'Informações de posicionamento do item',
   'ITEM_EDIT_25':'Nome',
   'ITEM_EDIT_26':'Posição',
   'ITEM_EDIT_27':'Rotação',
   'ITEM_EDIT_28':'Dimensão',
   'ITEM_EDIT_29':'Escala',
   'ITEM_EDIT_30':'Salvando a textura do seu item...aguarde',
   'ITEM_EDIT_31':'Objeto Dinâmico',
   'ITEM_EDIT_32':'Este objeto é dinâmico e se você estatizar ficará preso ao chão. Você deseja estatizar? (você pode dinamizar de novo usando ctrl-click no item)',
   'ITEM_EDIT_33':'Objeto estatizado',
   'ITEM_EDIT_34':'O objeto está preso no chão. Para editar novamente clique nele com CTRL apertado',
   'ITEM_EDIT_35':'Esse item não pode ser coletado',
   'ITEM_EDIT_36':'Apenas o dono do item pode coletar ele',
   'ITEM_EDIT_37':'Item coletado está agora na sua mochila',
   'ITEM_EDIT_38':'Espere',
   'ITEM_EDIT_39':'Você está coletando o item....demora um tempo...',
   'ITEM_EDIT_40':'Item coletado está agora na sua mochila',
   'ITEM_EDIT_41':'Um erro ocorreu ao tentar coletar o item e ele voltou a sua posição inicial',
   'ITEM_EDIT_42':'Trello',
   'ITEM_EDIT_43':'Definir posição inicial',
   'ITEM_EDIT_44':'Resetar posição inicial',
   'ITEM_EDIT_45':'Missões',
   'ITEM_EDIT_46':'Selecionar Missões',
   'ITEM_EDIT_47':'DELETAR',


	'CELL_NOTIFY_01':'TEXTO',
	'CELL_NOTIFY_02':'VIDEO',
	'CELL_NOTIFY_03':'Crie a sua Notificação',
	'CELL_NOTIFY_04':'Título',
	'CELL_NOTIFY_05':'VIDEO',
	'CELL_NOTIFY_06':'Enviar',
	'CELL_NOTIFY_07':'Criar notificação',

	'EDIT_ROOM_01':'Editar Sala',
	'EDIT_ROOM_02':'Dados da Sala',
	'EDIT_ROOM_03':'Nome',
	'EDIT_ROOM_04':'Setar Posição Inicial',
	'EDIT_ROOM_05':'Estatizar itens',
	'EDIT_ROOM_06':'Dinamizar itens',
	'EDIT_ROOM_07':'Salvar sala',
	'EDIT_ROOM_08':'Ajustar background 2D',
	'EDIT_ROOM_09':'Escolher Imagem',
	'EDIT_ROOM_10':'Posição',
	'EDIT_ROOM_11':'Selecionar',
	'EDIT_ROOM_12':'Salvar',
	'EDIT_ROOM_13':'Colisões',
	'EDIT_ROOM_14':'Editar',
	'EDIT_ROOM_15':'Salvar',
	'EDIT_ROOM_16':'Apagar',
	'EDIT_ROOM_17':'Criar chave',
	'EDIT_ROOM_18':'Fazer chave',
	'EDIT_ROOM_19':'Itens da empresa',
	'EDIT_ROOM_20':'Imagem',
	'EDIT_ROOM_21':'Qtd',
	'EDIT_ROOM_22':'Pegar',
	'EDIT_ROOM_23':'Salvar',
	'EDIT_ROOM_24':'Save',
	'EDIT_ROOM_25':'Save',
	'EDIT_ROOM_26':'Save',
}
 public es={
  'ENTER':'ENTRAR',
  'ERROR':'ERROR',
  'FAIL':'FALLA',
  'NO':' NO',
  'REGISTER':'REGISTRO',
  'SUCCESS':'ÉXITO',
  'TALENT':'TALENTO',
  'UNLOG':'CERRAR SESIÓN',
  'WAIT':'ESPERE',
  'WALLET':'BILLETERA',
  'YES':' SI',
  'SEARCH':'BUSCAR',
  'SAVE':' GUARDAR',


  'CHAT':'Chat',
  'ATTENTION':'Llamar la atención',
  'VIDEOCALL':'video conferencia',
  'TELEPORT':'Teleporte',
  'KICK':'Expulsar',
  'BAN':'Baneo/Prohibición',
  'TESTVIDEO':'VÍDEO DE PRUEBA',
  'DOREGISTER':'Registro',
  'CHANGEAVATAR':'Cambiar avatar',
  'TRADE':'Comercio',
  'TRANSFER':'Transferir',
  'CANCEL':'Cancelar',
  'CAMERA':'Cámara',
  'GOTO':'Ir para',
  'SCHEDULE':'Schedule',
  'NOTIFICATIONS':'Notifications',
  'ADDNOTIFICATIONS':'Create Notifications',
  'TASKS':'Tarefas',

  'EVENT_COMPONENT_0':'Uso em celular',
  'EVENT_COMPONENT_1':'Para melhorar seu uso, pedimos que você deixe o site em fullscreen e o celular na horizontal. E não se esqueça de habilitar o audio e microfone.',
  'EVENT_COMPONENT_2':'Dúvidas',
  'EVENT_COMPONENT_3':'Está com problemas? Podemos te enviar para a recepção onde nosso time vai tentar resolver ou esclarecer suas dúvidas. Você aceita?',
  'EVENT_COMPONENT_4':'Está com problemas? Podemos te enviar para a tela inicial de ajustes de câmera, audio e cadastramento para que você tente resolvê-las. Você aceita?',
  'EVENT_COMPONENT_5':'Pedido de contato',
  'EVENT_COMPONENT_6':'Pedido de ir para site',
  'EVENT_COMPONENT_7':' está pedindo que você vá para um outro site. Você aceita?',
  'EVENT_COMPONENT_8':'Pedido de Fix na Videoconferência',
  'EVENT_COMPONENT_9':' está pedindo que você atualize sua videoconferência para resolver um erro. Você aceita?',
  'EVENT_COMPONENT_10':"Mapa",
  'EVENT_COMPONENT_11':"Esse objeto está estático mas você é o dono e portanto pode torná-lo dinâmico. Você quer que ele fique dinâmico? ",
  'EVENT_COMPONENT_12':'Objeto dinamizado você agora pode movê-lo.',
  'EVENT_COMPONENT_13':"Esse objeto está estático e você não é o dono. Por isso você não pode editá-lo ",
  'EVENT_COMPONENT_14':'Você está distante deste objeto',
  'EVENT_COMPONENT_15':'Se aproxime do objeto para olhar seu conteúdo',
  'EVENT_COMPONENT_16':'Usuário deslogado',
  'EVENT_COMPONENT_17':'Você precisa se logar pra usar containers',
  'EVENT_COMPONENT_18':'Fix na Videoconferência',
  'EVENT_COMPONENT_19':'Vamos abrir os painéis de controle de audio na videoconferência. Verifique se o microfone e as saídas de audio estão bem configuradas.',
  'EVENT_COMPONENT_20':'Ir para o Mapa',
  'EVENT_COMPONENT_21':'Você quer ir para o mapa?',
  'EVENT_COMPONENT_22':'Área sem mapa',
  'EVENT_COMPONENT_23':'Essa área não possui acesso ao mapa habilitado.',
  'EVENT_COMPONENT_24':'Você não tem a chave',
  'EVENT_COMPONENT_25':'Procure uma pessoa que possa te dar a chave para trancar a porta.',
  'EVENT_COMPONENT_26':'Reunião local',
  'EVENT_COMPONENT_27':'Você aceitar ir para conferência local em: ',
  'EVENT_COMPONENT_28':'Videoconferência local',
  'EVENT_COMPONENT_29':'O seu audio está <b>saindo</b> do audio local para uma videoconferência privada em ',
  'EVENT_COMPONENT_30':'.<br><br> Você <b>apenas</b> ouvirá pessoas que também <b>entrarem</b> nessa videoconferência.<br><br> Para voltar ao modo de audio por proximidade clique no icone da porta no topo da tela.',
  'EVENT_COMPONENT_40':'Link para uma nova janela',
  'EVENT_COMPONENT_41':'Você será direcionado para uma nova página. Você aceita?',
  'EVENT_COMPONENT_42':'Visualizar ',
  'EVENT_COMPONENT_43':'Vamos abrir uma nova página de internet em outra aba do seu navegador com as informações do link ',
  'EVENT_COMPONENT_44':'. Você aceita?',
  'EVENT_COMPONENT_45':'Você está distante deste objeto',
  'EVENT_COMPONENT_46':'Se aproxime do objeto para interagir',
  'EVENT_COMPONENT_47':"Sem Permissão",
  'EVENT_COMPONENT_48':"Você não possui permissão para o painel de controle da sala.",
  'EVENT_COMPONENT_49':"Ver item compartilhado",
  'EVENT_COMPONENT_50':"Você deseja ver o item que acabou de compartilhar?",

  'AVATAR_COMPONENT_1':'¡Vamos a personalizar tu avatar!',
  'AVATAR_COMPONENT_2':'Cuerpo',
  'AVATAR_COMPONENT_3':'Opciones',
  'AVATAR_COMPONENT_4':'Piel',
  'AVATAR_COMPONENT_5':'Elegir color',
  'AVATAR_COMPONENT_6':'Intensidad',
  'AVATAR_COMPONENT_7':'Cabeza',
  'AVATAR_COMPONENT_8':'Ropa',
  'AVATAR_COMPONENT_9':'Pies',
  'AVATAR_COMPONENT_10':'Hombre',
  'AVATAR_COMPONENT_11':'Mujer',

  'CARD_COMPONENT_1':'Tarjeta de crédito',
  'CARD_COMPONENT_2':'Nombre en la tarjeta',
  'CARD_COMPONENT_3':' Actualmente, cada Livecoin cuesta $ 0,10. La compra mínima es de $ 1,00 (10 livecoins). ¿Cuántos Livecoin deseas comprar?',
  'CARD_COMPONENT_4':'Elige la cantidad a continuación',
  'CARD_COMPONENT_5':'Comprar',
  'CARD_COMPONENT_6':'Por favor, ponga el nombre de acuerdo con la tarjeta.',
  'CARD_COMPONENT_7':'Por favor, agregue el número de tarjeta de crédito.',
  'CARD_COMPONENT_8':'Por favor agregue CVC.',
  'CARD_COMPONENT_9':'Fecha de caducidad.',
  'CARD_COMPONENT_10':'La compra mínima es de R$ 1,00 (10 livecoins).',
  'CARD_COMPONENT_11':'Procesando tu compra. Esperar.',
  'CARD_COMPONENT_12':' Tus livecoins se compraron con éxito y se agregaron a tu billetera.',
  'CARD_COMPONENT_13':' Ocurrió un error al procesar la compra. La transacción se registró y puede volver a intentarlo.',

  'CHECKVIDEO_COMPONENT_1':'Prueba tu',
  'CHECKVIDEO_COMPONENT_2':'Video conferencia',
  'CHECKVIDEO_COMPONENT_3':'Haz clic en',
  'CHECKVIDEO_COMPONENT_4':'Permitir',
  'CHECKVIDEO_COMPONENT_5':' Si el navegador solicita acceso a Cámara y Micrófono',
  'CHECKVIDEO_COMPONENT_6':' Si puede verse a sí mismo o la cámara está grabando, entonces está funcionando correctamente.',
  'CHECKVIDEO_COMPONENT_7':'¿Problemas con tu cámara?',
  'CHECKVIDEO_COMPONENT_8':'¿Problemas con tu micrófono?',
  'CHECKVIDEO_COMPONENT_9':'¿Problemas con tu audio?',
  'CHECKVIDEO_COMPONENT_10':'¿Compatibilidad con navegadores?',
  'CHECKVIDEO_COMPONENT_11':'Registrarse',
  'CHECKVIDEO_COMPONENT_12':'Elige tu avatar',
  'CHECKVIDEO_COMPONENT_13':'Mire el tutorial a continuación para problemas relacionados con la cámara',
  'CHECKVIDEO_COMPONENT_14':'Si aún tiene problemas, comunicate con nosotros a través de',
  'CHECKVIDEO_COMPONENT_15':'Mire el tutorial a continuación por problemas relacionados con el audio',
  'CHECKVIDEO_COMPONENT_16':'Error de micrófono',
  'CHECKVIDEO_COMPONENT_17':"Hemos detectado un error en su micrófono. Estamos abriendo los ajustes para que configures el micrófono y el audio",
  'CHECKVIDEO_COMPONENT_18':"Error de cámara",
  'CHECKVIDEO_COMPONENT_19':"Hemos detectado un error en tu cámara. Estamos abriendo los ajustes para que configures la cámara",
  'CHECKVIDEO_COMPONENT_20':'Error de cámara.',
  'CHECKVIDEO_COMPONENT_21':'Le sugerimos que resuelva este problema presionando el botón Problemas con su cámara. Si lo desea, haga clic en ENTRAR a continuación para hablar por videoconferencia con uno de nuestros recepcionistas para ayudarlo.',
  'CHECKVIDEO_COMPONENT_22':'Hay un problema con tu audio.',
  'CHECKVIDEO_COMPONENT_23':'Le sugerimos que resuelva este problema presionando el botón Problemas con su audio. Si lo desea, haga clic en ENTRAR a continuación para hablar por videoconferencia con uno de nuestros recepcionistas para ayudarlo.',
  'CHECKVIDEO_COMPONENT_24':'Hay un problema con tu micrófono.',
  'CHECKVIDEO_COMPONENT_25':'Le sugerimos que resuelva este problema presionando el botón Problemas con su micrófono. Si lo desea, haga clic en ENTRAR a continuación para hablar por videoconferencia con uno de nuestros recepcionistas para ayudarlo.',
  'CHECKVIDEO_COMPONENT_26':'No registrado.',
  'CHECKVIDEO_COMPONENT_27':'No estás registrado. Haga clic en Registrarse para iniciar sesión. También puede iniciar sesión sin registrarse haciendo clic en ENTRAR.',
  'CHECKVIDEO_COMPONENT_28':'¡Todo listo!',
  'CHECKVIDEO_COMPONENT_29':"Todo está listo para que ingrese. Puede hacer clic en ENTRAR e ir directamente al metaverso.",

  'PROFILE_COMPONENT_1':'Foto de perfil',
  'PROFILE_COMPONENT_2':'Enviar la dirección de la billetera al correo electrónico',
  'PROFILE_COMPONENT_3':'Comprar Livecoins',
  'PROFILE_COMPONENT_4':'Historial de compras de Livecoins',
  'PROFILE_COMPONENT_5':'Escriba su correo electrónico',
  'PROFILE_COMPONENT_6':'dd/mm/yyyy',
  'PROFILE_COMPONENT_7':'Acerca de ti',
  'PROFILE_COMPONENT_8':'Revisa tu correo electrónico registrado en liveplanet. La llave de tu billetera estará allí.',
  'PROFILE_COMPONENT_9':'Hubo un error al enviar los datos de su billetera a su correo electrónico.',
  'PROFILE_COMPONENT_10':'El usuario es nulo',
  'PROFILE_COMPONENT_11':'Nombre incompleto',
  'PROFILE_COMPONENT_12':'Correo electrónico incompleto',
  'PROFILE_COMPONENT_13':'Teléfono incompleto',
  'PROFILE_COMPONENT_14':'Fecha de nacimiento incompleta',
  'PROFILE_COMPONENT_15':'Sin imagen',
  'PROFILE_COMPONENT_16':'Sin dirección',
  'PROFILE_COMPONENT_17':"Por favor escriba su nombre.",
  'PROFILE_COMPONENT_18':"Por favor escriba su correo electrónico.",
  'PROFILE_COMPONENT_19':"Los datos del perfil se guardaron correctamente.",
  'PROFILE_COMPONENT_20':"¡¡Vamos!!",
  'PROFILE_COMPONENT_21':'Estás en la lista de asistentes al evento. Cuando comience el evento, haga clic en ÚNASE AL EVENTO',

  'GAME_USERLOGIN_COMPONENT_1':'Iniciar sesión con correo electrónico y contraseña',
  'GAME_USERLOGIN_COMPONENT_2':'Escriba su correo electrónico',
  'GAME_USERLOGIN_COMPONENT_3':'Escribe tu contraseña',
  'GAME_USERLOGIN_COMPONENT_4':'Olvidé mi contraseña',
  'GAME_USERLOGIN_COMPONENT_5':'Seguir conectado',
  'GAME_USERLOGIN_COMPONENT_6':'Inicie sesión y disfrute del metaverso',
  'GAME_USERLOGIN_COMPONENT_7':'Escriba su nombre completo',
  'GAME_USERLOGIN_COMPONENT_8':'Selecciona tu avatar',
  'GAME_USERLOGIN_COMPONENT_9':'Repite la contraseña',
  'GAME_USERLOGIN_COMPONENT_10':'He leído y acepto los Términos y Condiciones',
  'GAME_USERLOGIN_COMPONENT_11':"Complete su dirección de correo electrónico para que podamos enviarle una nueva solicitud de contraseña.",
  'GAME_USERLOGIN_COMPONENT_12':"Solicitud de restablecimiento de contraseña enviada a su correo electrónico.",
  'GAME_USERLOGIN_COMPONENT_13':"Se ha producido un error. ¿Estás seguro de que te registraste? Vale la pena intentar registrarse con este correo electrónico.",
  'GAME_USERLOGIN_COMPONENT_14':"Ingrese su nombre para que las personas puedan encontrarlo en la plataforma",
  'GAME_USERLOGIN_COMPONENT_15':"Por favor complete su correo electrónico.",
  'GAME_USERLOGIN_COMPONENT_16':"Tu contraseña tiene que tener 8 dígitos.",
  'GAME_USERLOGIN_COMPONENT_17':"Your password has to be confirmed",
  'GAME_USERLOGIN_COMPONENT_18':'Register done',
  'GAME_USERLOGIN_COMPONENT_19':'You are registered. How about you now set your avatar?',
  'GAME_USERLOGIN_COMPONENT_20':"This email is already registered...try again with another email or contact us at contato@liveparty.com.br",
  'GAME_USERLOGIN_COMPONENT_21':"Inicio de sesión exitoso",
  'GAME_USERLOGIN_COMPONENT_22':"Error no identificado en el registro de usuario.",
  'GAME_USERLOGIN_COMPONENT_23':"Contraseña incorrecta para el correo electrónico registrado",
  'GAME_USERLOGIN_COMPONENT_24':"El correo electrónico no encontrado.",
  'GAME_USERLOGIN_COMPONENT_25':"Límite excedido. Espere unos minutos y vuelva a intentarlo.",
  'GAME_USERLOGIN_COMPONENT_26':"Termos e condições de uso de dados.",

  'APPSCREEN_COMPONENT_1':'Usuarios en la sala',
  'APPSCREEN_COMPONENT_2':'Salas',
  'APPSCREEN_COMPONENT_3':'Contacto',
  'APPSCREEN_COMPONENT_4':'Galeria',
  'APPSCREEN_COMPONENT_5':'Salas favoritas',
  'APPSCREEN_COMPONENT_6':'Notificación',
  'APPSCREEN_COMPONENT_7':'Editar',
  'CONTACT_SCREEN_COMPONENT_1':'Contactos en la sala ',
  'CONTACT_SCREEN_COMPONENT_2':'Buscar contactos',
  'CONTACT_SCREEN_COMPONENT_3':"Video conferencia",
  'CONTACT_SCREEN_COMPONENT_4':" ¿Deseas invitar a este usuario a una videoconferencia?",
  'CONTACT_SCREEN_COMPONENT_5':'Eliminar usuario de la sala',
  'CONTACT_SCREEN_COMPONENT_6':'¿Desea eliminar ',
  'CONTACT_SCREEN_COMPONENT_7':'Prohibir al usuario de la sala',
  'CONTACT_SCREEN_COMPONENT_8':'¿Desea prohibir',
  'CONTACT_SCREEN_COMPONENT_9':'? La persona escuchará un sonido para abrir la plataforma.',
  'CONTACT_SCREEN_COMPONENT_10':'No eres un administrador de la sala. Solo los administradores pueden prohibir a los usuarios.',
  'CONTACT_SCREEN_COMPONENT_11':'¿Quieres llamar la atención de',
  'CONTACT_SCREEN_COMPONENT_12':'Llamar la atención',
  'CONTACT_SCREEN_COMPONENT_13':' Llamar la atención.',
  'CONTACT_SCREEN_COMPONENT_14':"TELEPORTE",
  'CONTACT_SCREEN_COMPONENT_15':"¿Quieres invitar a este usuario a teletransportarte a donde estás?",
  'CONTACT_SCREEN_COMPONENT_15a':"Você deseja se teleportar para a posição deste usuário?",
  'CONTACT_SCREEN_COMPONENT_16':'Invitación enviada',
  'CONTACT_SCREEN_COMPONENT_17':' fue invitado a teletransportarse a donde usted está. Esperar respuesta',
  'CONTACT_SCREEN_COMPONENT_18':"Solicitud de teletransporte",
  'CONTACT_SCREEN_COMPONENT_19':" te está invitando a ir al evento donde te encuentres. ¿Quieres ir?",
  'CONTACT_SCREEN_COMPONENT_20':' fue invitado a chatear contigo. Espere respuesta.',
  'CONTACT_SCREEN_COMPONENT_21':"Solicitud de videoconferencia",
  'CONTACT_SCREEN_COMPONENT_22':" te está invitando a ir a chatear por videoconferencia. ¿Aceptas?",
  'CONTACT_SCREEN_COMPONENT_23':"Eliminación",
  'CONTACT_SCREEN_COMPONENT_24':' eliminado de la habitación.',
  'CONTACT_SCREEN_COMPONENT_25':"Expulsión",
  'CONTACT_SCREEN_COMPONENT_26':" te prohibió la entrada a la sala.",

  'FAVORITE_ROOM_SCREEN_1':'Buscar salas',
  'FAVORITE_ROOM_SCREEN_2':'Añadir sala',
  'FAVORITE_ROOM_SCREEN_3':'Ir a la sala',
  'FAVORITE_ROOM_SCREEN_4':'Editar sala',
  'FAVORITE_ROOM_SCREEN_5':'Quitar sala',
  'FAVORITE_ROOM_SCREEN_6':'Favorito',
  'FAVORITE_ROOM_SCREEN_7':'Esta sala ya se ha marcado como favorita.',
  'FAVORITE_ROOM_SCREEN_8':"En la sala",
  'FAVORITE_ROOM_SCREEN_9':"Ya estás en esta sala..",
  'FAVORITE_ROOM_SCREEN_10':"¿Desea teletransportarse a este lugar?",
  'FAVORITE_ROOM_SCREEN_11':'Eliminación',
  'FAVORITE_ROOM_SCREEN_12':"¿Quieres eliminar esta sala de tu lista de favoritos?",
  'FAVORITE_ROOM_SCREEN_13':'Editar sala',
  'FAVORITE_ROOM_SCREEN_14':'Describe el nombre de la habitación para que te sea fácil identificarla',
  'FAVORITE_ROOM_SCREEN_15': 'Sala completa',
  'FAVORITE_ROOM_SCREEN_16':"Esta sala tiene 70 usuarios y está llena. Espera a que alguien se vaya para poder entrar.",
  'FAVORITE_ROOM_SCREEN_17':"Esta habitación tiene",
  'FAVORITE_ROOM_SCREEN_18':" usuarios de 70. Puedes entrar. ",

  'GALLERY_SCREEN_COMPONENT':'Subir imágenes',

  'PROFILE_SCREEN_1':'Teléfono',
  'PROFILE_SCREEN_2':'Cumpleaños',

  'CONTAINER_MODAL_0':'Mochila',
  'CONTAINER_MODAL_1':'Cabello',
  'CONTAINER_MODAL_2':'Torso',
  'CONTAINER_MODAL_3':'mano izquierda',
  'CONTAINER_MODAL_4':'pies',
  'CONTAINER_MODAL_5':'cuello',
  'CONTAINER_MODAL_6':'piernas',
  'CONTAINER_MODAL_7':'mano derecha',
  'CONTAINER_MODAL_8':'dedos',
  'CONTAINER_MODAL_9':'pierna',
  'CONTAINER_MODAL_10':'Equipar',
  'CONTAINER_MODAL_11':'Equipando artículo... espera...',
  'CONTAINER_MODAL_12':'Desequipar',
  'CONTAINER_MODAL_13':'¿Quieres desequipar este artículo?',
  'CONTAINER_MODAL_14':'vacío',
  'CONTAINER_MODAL_15':'Artículo equipado',
  'CONTAINER_MODAL_16':'Desequipa este objeto para poder pintar.',
  'CONTAINER_MODAL_17':'Transferir artículo',
  'CONTAINER_MODAL_18':'¿Desea transferir este artículo al contenedor?',
  'CONTAINER_MODAL_19':"Artículo no disponible",
  'CONTAINER_MODAL_20':" Este artículo, aunque tuyo, no está en tu mochila. Asegúrese de que no se haya puesto en el piso o en un vendedor.",
  'CONTAINER_MODAL_21':"Convertir token",
  'CONTAINER_MODAL_22':" Tiene derecho a un artículo de este token. Desea convertir el token en un elemento de tipo",
  'CONTAINER_MODAL_23':"manipular artículo",
  'CONTAINER_MODAL_24':"Este artículo no se puede compartir.",
  'CONTAINER_MODAL_25':'Invitación a ver objeto',
  'CONTAINER_MODAL_26':' Me gustaría compartir un enlace con usted. ¿Aceptas?',
  'CONTAINER_MODAL_27':"Ver elemento compartido",
  'CONTAINER_MODAL_28':"¿Quieres ver el artículo que acabas de compartir?",
  'CONTAINER_MODAL_29':"Este artículo está equipado. Quitarlo para ponerlo en el suelo.",
  'CONTAINER_MODAL_30':"¡Este artículo es súper importante! No lo pierdas.",
  'CONTAINER_MODAL_31':"Está en una habitación temporal y no puede dejar su artículo en el suelo.",
  'CONTAINER_MODAL_32':'Caer al suelo',
  'CONTAINER_MODAL_33':'Estás quitando el artículo al piso. Este artículo, cuando se coloca en el piso, sale de su billetera y está disponible para que otros lo vean y lo recojan. ¿Confirmas que quieres poner este artículo en el suelo?',
  'CONTAINER_MODAL_34':"Este artículo es un nft y no se puede quitar al suelo.",
  'CONTAINER_MODAL_35':'Manipular clave',
  'CONTAINER_MODAL_36':'Esta clave está conectada a la sala de códigos.:',
  'CONTAINER_MODAL_37':"Cambiar nombre",
  'CONTAINER_MODAL_38':"Introduce un nombre para esta clave.",
  'CONTAINER_MODAL_39':'. ¿Qué deseas hacer?',
  'CONTAINER_MODAL_40':'Lugar equivocado',
  'CONTAINER_MODAL_41':"Este título no está relacionado con esta sala, por lo que no se puede utilizar aquí.",
  'CONTAINER_MODAL_42':'Objeto escrito',
  'CONTAINER_MODAL_43':'Este objeto ya está escrito con un enlace para ver un sitio externo. ¿Desea abrir y leer el sitio externo o desea borrar el contenido y escribir un nuevo sitio externo?',
  'CONTAINER_MODAL_44':'Leer',
  'CONTAINER_MODAL_45':"Escribe",
  'CONTAINER_MODAL_46':'Objeto equipable',
  'CONTAINER_MODAL_47':'¿Quieres llevar este artículo?',
  'CONTAINER_MODAL_48':'pintar objeto',
  'CONTAINER_MODAL_49':'Haga clic en el objeto que desea pintar.',
  'CONTAINER_MODAL_50':"Introduce un nombre para este objeto.",
  'CONTAINER_MODAL_51':"Ingrese el enlace a dónde ir al hacer clic en el objeto",
  'CONTAINER_MODAL_52':'Rellene una dirección URL válida',
  'CONTAINER_MODAL_53':"Haga clic en el elemento para usar o equipar",
  'CONTAINER_MODAL_54':"Haga clic en el elemento para transferir al mapa",
  'CONTAINER_MODAL_55':"Artículos en el piso del mapa para recolectar",
  'CONTAINER_MODAL_56':"Escriba su nombre",
  'CONTAINER_MODAL_57':"Empty",

  'EVENT_COMPONENT_1a':'Ampliar el zoom',
  'EVENT_COMPONENT_2a':'Disminuir el zoom',
  'EVENT_COMPONENT_3a':'Herramientas',
  'EVENT_COMPONENT_4a':'Teléfono móvil',
  'EVENT_COMPONENT_5a':'Audio',
  'EVENT_COMPONENT_6a':'Editar Avatar',
  'EVENT_COMPONENT_7a':'Compartir',
  'EVENT_COMPONENT_8a':'Libreta de notas',
  'EVENT_COMPONENT_9a':'Abandonar',
  'EVENT_COMPONENT_10a':'Transmisión',

  'TRANSITION_TITLE':'Transición',
  'TRANSITION_MESSAGE1':'Este lugar tiene ',
  'TRANSITION_MESSAGE2':" de 70 usuarios. Puedes entrar.",

  'YOUTUBE_COMPONENT_1':"Clic y empuje ",
  'YOUTUBE_COMPONENT_2':"(despacio)",

  'TUTORIAL_COMPONENT_1':"Bem vindo ao metaverso!! Conversas são por audio - autorize uso do microfone.",
  'TUTORIAL_COMPONENT_2':"Headphones são bem vindos. Ajudam você a ouvir os outros",
  'TUTORIAL_COMPONENT_3':"Liveplanet é muito melhor se visto em widescreen.",
  'TUTORIAL_COMPONENT_4':"O cadastro não é obrigatório, mas é indicado para você ter um nome e avatar.",

  'DOOR_BEAN_0':'Porta',
  'DOOR_BEAN_1':'Lotado',
  'DOOR_BEAN_2':'Este local possui ',
  'DOOR_BEAN_3':' usuários e está cheio. Aguarde alguém sair para você poder entrar.',
  'DOOR_BEAN_4':'trancar',
  'DOOR_BEAN_5':'destrancar',
  'DOOR_BEAN_6':'Você deseja utilizar a porta?',
  'DOOR_BEAN_7':'Entrar',
  'DOOR_BEAN_8':'Sair',
  'DOOR_BEAN_9':'Para manipular esse item você deve primeiro posicionar ela no chão de uma sala',
  'DOOR_BEAN_10':'A porta já está configurada. Você deseja reconfigurar ou usar?',
  'DOOR_BEAN_11':'Reconfigurar',
  'DOOR_BEAN_12':'A porta não está configurada. Você deseja configurar ou usar?',
  'DOOR_BEAN_13':'Configurar',
  'DOOR_BEAN_14':'Usar',
  'DOOR_BEAN_15':'Para qual função você usará essa porta?',
  'DOOR_BEAN_16':'Outra sala',
  'DOOR_BEAN_17':'Mesma sala',
  'DOOR_BEAN_18':'Configurar porta mesma sala',
  'DOOR_BEAN_19':'Sua porta está posicionada e na orientação certa?',
  'DOOR_BEAN_20':'Configuração de porta errada',
  'DOOR_BEAN_21':'Posicione e oriente a porta antes de fazer essa configuração',
  'DOOR_BEAN_30':'Porta atualizada',
  'DOOR_BEAN_31':'A porta foi atualizada com sucesso. Se no futuro movê-la precisará editar novamente',
  'DOOR_BEAN_32':'Para fora',
  'DOOR_BEAN_33':'Selecione a sala:',
  'DOOR_BEAN_34':'Porta Trancada',
  'DOOR_BEAN_35':'Esta porta está trancada e você não possui a chave. Se você comprou ingresso, clique no simbolo da empresa onde você comprou para obter a chave a partir do seu ingresso. Se você não comprou ingresso, busque um outro usuário na plataforma ou um NPC para liberar acesso.',
  'DOOR_BEAN_36':'Porta não configurada',
  'DOOR_BEAN_37':'Essa porta não está configurada. Configure ela antes de usar',


   'ITEM_EDIT_0':'Usar',
   'ITEM_EDIT_1':'Coletar',
   'ITEM_EDIT_2':'Estático',
   'ITEM_EDIT_3':'Girar',
   'ITEM_EDIT_4':'Textura 2D',
   'ITEM_EDIT_5':'Textura 3D',
   'ITEM_EDIT_6':'Ações',
   'ITEM_EDIT_7':'Posicionamento',
   'ITEM_EDIT_8':'Atualizar Textura',
   'ITEM_EDIT_9':'Apagar Textura',
   'ITEM_EDIT_10':'Atualizar Item',
   'ITEM_EDIT_11':'Selecione a ação do objeto',
   'ITEM_EDIT_12':'Defina a URL do site',
   'ITEM_EDIT_13':'Defina o vídeo',
   'ITEM_EDIT_14':'Texto',
   'ITEM_EDIT_15':'Defina o áudio do objeto',
   'ITEM_EDIT_16':'Defina a imagem a conectar neste objeto',
   'ITEM_EDIT_17':'Escolha o NPC',
   'ITEM_EDIT_18':'Editar Avatar',
   'ITEM_EDIT_19':'Escolha ação que ocorre próximo do objeto',
   'ITEM_EDIT_20':'Defina a URL do site que será embedado',
   'ITEM_EDIT_21':'Mutado',
   'ITEM_EDIT_22':'Defina a URL do site a ser exposto quando próximo ao item',
   'ITEM_EDIT_23':'Defina distância em X e Y de ativação',
   'ITEM_EDIT_24':'Informações de posicionamento do item',
   'ITEM_EDIT_25':'Nome',
   'ITEM_EDIT_26':'Posição',
   'ITEM_EDIT_27':'Rotação',
   'ITEM_EDIT_28':'Dimensão',
   'ITEM_EDIT_29':'Escala',
   'ITEM_EDIT_30':'Salvando a textura do seu item...aguarde',
   'ITEM_EDIT_31':'Objeto Dinâmico',
   'ITEM_EDIT_32':'Este objeto é dinâmico e se você estatizar ficará preso ao chão. Você deseja estatizar? (você pode dinamizar de novo usando ctrl-click no item)',
   'ITEM_EDIT_33':'Objeto estatizado',
   'ITEM_EDIT_34':'O objeto está preso no chão. Para editar novamente clique nele com CTRL apertado',
   'ITEM_EDIT_35':'Esse item não pode ser coletado',
   'ITEM_EDIT_36':'Apenas o dono do item pode coletar ele',
   'ITEM_EDIT_37':'Item coletado está agora na sua mochila',
   'ITEM_EDIT_38':'Espere',
   'ITEM_EDIT_39':'Você está coletando o item....demora um tempo...',
   'ITEM_EDIT_40':'Item coletado está agora na sua mochila',
   'ITEM_EDIT_41':'Um erro ocorreu ao tentar coletar o item e ele voltou a sua posição inicial',


	'CELL_NOTIFY_01':'TEXTO',
	'CELL_NOTIFY_02':'VIDEO',
	'CELL_NOTIFY_03':'Crie a sua Notificação',
	'CELL_NOTIFY_04':'Título',
	'CELL_NOTIFY_05':'VIDEO',
	'CELL_NOTIFY_06':'Enviar',
	'CELL_NOTIFY_07':'Criar notificação',
}

public en={
  'ENTER':'Enter',
  'ERROR':'Error',
  'FAIL':'Fail',
  'NO':' No',
  'REGISTER':'Register',
  'SUCCESS':'Success',
  'TALENT':'Talent',
  'UNLOG':'Logout',
  'WAIT':'Wait',
  'WALLET':'Wallet',
  'YES':' Yes',
  'SEARCH':'Search',
  'SAVE':' Save',
  'CHAT':'Chat',
  'ATTENTION':'Call attention',
  'VIDEOCALL':'Videoconference',
  'TELEPORT':'Teleport',
  'KICK':'Kickout',
  'BAN':'Ban from room',
  'TESTVIDEO':'Test Video',
  'DOREGISTER':'Register',
  'CHANGEAVATAR':'Change Avatar',
  'TRADE':'Trade',
  'TRANSFER':'Transfer',
  'CANCEL':'Cancel',
  'CAMERA':'Camera',
  'GOTO':'Go to',
  'SCHEDULE':'Schedule',
  'NOTIFICATIONS':'Notifications',
  'ADDNOTIFICATIONS':'Create Notifications',
  'TASKS':'Tasks',

  'EVENT_COMPONENT_0':'Use in cellphone',
  'EVENT_COMPONENT_1':'To improve use, we ask you to keep your browser in fullscreen and cellphone horizontally. Dont forget to allow microphone and camera.',
  'EVENT_COMPONENT_2':'Doubts',
  'EVENT_COMPONENT_3':'Any problems? We will send you to the reception of our team where we can try resolve your questions. Do you accept?',
  'EVENT_COMPONENT_4':'Any problems? We can send you to the initial screen to adjust camera, audio and register. Do you accept?',
  'EVENT_COMPONENT_5':'Contact request',
  'EVENT_COMPONENT_6':'Request to go to website',
  'EVENT_COMPONENT_7':' is asking you to go to another site. Do you accept?',
  'EVENT_COMPONENT_8':'Request to fix videoconference',
  'EVENT_COMPONENT_9':' is asking you to verify if your videoconference is ok. Do you accept?',
  'EVENT_COMPONENT_10':"Map",
  'EVENT_COMPONENT_11':"This object is static, but you are the owner so you can turn it dinamic. Do you want to dinamize it? ",
  'EVENT_COMPONENT_12':'Object is now dinamic and you can move it.',
  'EVENT_COMPONENT_13':"This object is static and you are not the owner. You cant edit it ",
  'EVENT_COMPONENT_14':'You are far away from this object',
  'EVENT_COMPONENT_15':'Get closer to the object to interact',
  'EVENT_COMPONENT_16':'Anonymous user',
  'EVENT_COMPONENT_17':'You need to log to use that',
  'EVENT_COMPONENT_18':'Fix on Videoconference',
  'EVENT_COMPONENT_19':'We are opening the panels of control of audio of videoconference. Verify if microphone and audio is correctly configured.',
  'EVENT_COMPONENT_20':'Goto map',
  'EVENT_COMPONENT_21':'Do you want to go to the map?',
  'EVENT_COMPONENT_22':'Area without map',
  'EVENT_COMPONENT_23':'This region dont allow access to any map.',
  'EVENT_COMPONENT_24':'You dont have a key',
  'EVENT_COMPONENT_25':'Look for someone who can give you authorization to enter.',
  'EVENT_COMPONENT_26':'Local meeting',
  'EVENT_COMPONENT_27':'Do you want to go to the local meeting in: ',
  'EVENT_COMPONENT_28':'Local videoconfernece',
  'EVENT_COMPONENT_29':'Your audio is <b>leaking</b> from your local audio to the videoconference in ',
  'EVENT_COMPONENT_30':'.<br><br> You can <b>only</b> hear people who also <b>enter</b> this videoconfenrece.<br><br> Para voltar ao modo de audio por proximidade clique no icone da porta no topo da tela.',
  'EVENT_COMPONENT_40':'Link to a new window',
  'EVENT_COMPONENT_41':'You will be directed to a new page. Do you accept?',
  'EVENT_COMPONENT_42':'View ',
  'EVENT_COMPONENT_43':'We will open a new webpage on a new tab with informations of the link ',
  'EVENT_COMPONENT_44':'. Do you accept?',
  'EVENT_COMPONENT_45':'You are far away from this object',
  'EVENT_COMPONENT_46':'Get closer to the object to interact',
  'EVENT_COMPONENT_47':"No permission",
  'EVENT_COMPONENT_48':"You dont have permission to use the control panel.",
  'EVENT_COMPONENT_49':"See shared item",
  'EVENT_COMPONENT_50':"Do you want to see the item you just shared?",

  'AVATAR_COMPONENT_0':'Customize your Avatar',
  'AVATAR_COMPONENT_1':'Lets customize your avatar!',
  'AVATAR_COMPONENT_2':'Gender',
  'AVATAR_COMPONENT_3':'Options',
  'AVATAR_COMPONENT_4':'Skin',
  'AVATAR_COMPONENT_5':'Choose color',
  'AVATAR_COMPONENT_6':'Intensity',
  'AVATAR_COMPONENT_7':'Hair',
  'AVATAR_COMPONENT_8':'Chest',
  'AVATAR_COMPONENT_9':'Feet',
  'AVATAR_COMPONENT_10':'Male',
  'AVATAR_COMPONENT_11':'Female',
  'AVATAR_COMPONENT_12': 'Colour of',
  'AVATAR_COMPONENT_13': 'Legs',
  'AVATAR_COMPONENT_14': 'Pre-made avatars',
  'AVATAR_COMPONENT_15':'Equipped',
  'AVATAR_COMPONENT_16': 'Image',
  'AVATAR_COMPONENT_17': 'Name',
  'AVATAR_COMPONENT_18': 'Select',
  'AVATAR_COMPONENT_19': 'Polo',
  'AVATAR_COMPONENT_20': 'Regatta',
  'AVATAR_COMPONENT_21': 'T-shirt',
  'AVATAR_COMPONENT_22': 'Social',
  'AVATAR_COMPONENT_23': 'Shorts',
  'AVATAR_COMPONENT_24': 'Trousers',
  'AVATAR_COMPONENT_25': 'Speedos',
  'AVATAR_COMPONENT_26': 'Shoes',
  'AVATAR_COMPONENT_27': 'Slipper',
  'AVATAR_COMPONENT_28': 'Short',
  'AVATAR_COMPONENT_29': 'Full',
  'AVATAR_COMPONENT_30': 'Topknot',
  'AVATAR_COMPONENT_31': 'Big Topknot',
  'AVATAR_COMPONENT_32': 'Sideways',
  'AVATAR_COMPONENT_33': 'Fringe',
  'AVATAR_COMPONENT_34': 'Afro',
  'AVATAR_COMPONENT_35': 'Bald',
  'AVATAR_COMPONENT_36': 'Strap Tank Top',
  'AVATAR_COMPONENT_37': 'Tank Top',
  'AVATAR_COMPONENT_38': 'Dress',
  'AVATAR_COMPONENT_39': 'Triathlon suit',
  'AVATAR_COMPONENT_40': 'Jeans',
  'AVATAR_COMPONENT_41': 'Panties',
  'AVATAR_COMPONENT_42': 'Boots',
  'AVATAR_COMPONENT_43': 'High boots',
  'AVATAR_COMPONENT_44': 'Creating Avatar',
  'AVATAR_COMPONENT_45': 'Your avatar is being processed in several positions. This may take a while, but we need you to stay with this window open to garantee a good avatar creation.',
  'AVATAR_COMPONENT_46': 'Error Creating Avatar',
  'AVATAR_COMPONENT_47': 'We had to stop processing your avatar because you closed the tab or the window. You have to stay with the screen open until it ends. You can try again.',
  'AVATAR_COMPONENT_48': 'Choose Avatar',
  'AVATAR_COMPONENT_49': 'You want to use this avatar?',
  'AVATAR_COMPONENT_50': 'Pre-Made',


  'CARD_COMPONENT_1':'Credit Card',
  'CARD_COMPONENT_2':'Name in the card',
  'CARD_COMPONENT_3':' At the moment each Livecoin costs R$0.10. Minimum purchase is R$1,00 (10 livecoins). How many livecoins do you wish to purchase?',
  'CARD_COMPONENT_4':'Choose quantity below',
  'CARD_COMPONENT_5':'Buy',
  'CARD_COMPONENT_6':'Please put the name acording to the card',
  'CARD_COMPONENT_7':'Please add credit card number.',
  'CARD_COMPONENT_8':'Please add CVC.',
  'CARD_COMPONENT_9':'Expiry Date.',
  'CARD_COMPONENT_10':'Minimum purchase is R$1,00 (10 livecoins).',
  'CARD_COMPONENT_11':'Processing your purchase. Wait.',
  'CARD_COMPONENT_12':' Your livecoins were successfully purchased and added to your wallet.',
  'CARD_COMPONENT_13':' An error ocurred while processing the purchase. The transaction was recorded and you can try again.',

  'CHECKVIDEO_COMPONENT_1':'Test your',
  'CHECKVIDEO_COMPONENT_2':'Videoconference',
  'CHECKVIDEO_COMPONENT_3':'Click on',
  'CHECKVIDEO_COMPONENT_4':'Allow',
  'CHECKVIDEO_COMPONENT_5':' If the browser request access to Camera and Microphone.',
  'CHECKVIDEO_COMPONENT_6':' If you can see yourself or the camera is recording than is working correctly.',
  'CHECKVIDEO_COMPONENT_7':'Problems with your camera?',
  'CHECKVIDEO_COMPONENT_8':'Problems with your microphone?',
  'CHECKVIDEO_COMPONENT_9':'Problems with your audio?',
  'CHECKVIDEO_COMPONENT_10':'Browser compatibility?',
  'CHECKVIDEO_COMPONENT_11':'Register',
  'CHECKVIDEO_COMPONENT_12':'Choose your avatar',
  'CHECKVIDEO_COMPONENT_13':'Watch the tutorial below for camera related issues',
  'CHECKVIDEO_COMPONENT_14':'If you still have issues, please reach out to us through',
  'CHECKVIDEO_COMPONENT_15':'Watch the tutorial below for audio related issues',
  'CHECKVIDEO_COMPONENT_16':'Microphone error',
  'CHECKVIDEO_COMPONENT_17':"We've detected an error in your microphone. We are opening the settings for you to configure the microphone and audio",
  'CHECKVIDEO_COMPONENT_18':"Camera error",
  'CHECKVIDEO_COMPONENT_19':"We've detected an error in your camera. We are opening the settings for you to configure the camera",
  'CHECKVIDEO_COMPONENT_20':'Camera error.',
  'CHECKVIDEO_COMPONENT_21':'We suggest that you solve this problem by pressing the Problems with your camera button. If you want, click ENTER below to speak by videoconference with one of our receptionists to help you.',
  'CHECKVIDEO_COMPONENT_22':'There is an issue with your audio.',
  'CHECKVIDEO_COMPONENT_23':'We suggest that you solve this problem by pressing the Problems with your audio button. If you want, click ENTER below to speak by videoconference with one of our receptionists to help you.',
  'CHECKVIDEO_COMPONENT_24':'There is an issue with your microphone.',
  'CHECKVIDEO_COMPONENT_25':'We suggest that you solve this problem by pressing the Problems with your microphone button. If you want, click ENTER below to speak by videoconference with one of our receptionists to help you.',
  'CHECKVIDEO_COMPONENT_26':'Unregistered.',
  'CHECKVIDEO_COMPONENT_27':'You are unregistered. Click Register to login. You can also log in unregistered by clicking enter.',
  'CHECKVIDEO_COMPONENT_28':'All set!',
  'CHECKVIDEO_COMPONENT_29':"It's all ready for you to enter. You can click ENTER and go straight to the metaverse.",

  'PROFILE_COMPONENT_1':'Profile picture',
  'PROFILE_COMPONENT_2':'Send wallet address to e-mail',
  'PROFILE_COMPONENT_3':'Buy Livecoins',
  'PROFILE_COMPONENT_4':'Livecoins purchase history',
  'PROFILE_COMPONENT_5':'Type your e-mail',
  'PROFILE_COMPONENT_6':'dd/mm/yyyy',
  'PROFILE_COMPONENT_7':'About you',
  'PROFILE_COMPONENT_8':'Check your email registered on liveplanet. Your wallet key will be there.',
  'PROFILE_COMPONENT_9':'There was an error sending your wallet data to your email.',
  'PROFILE_COMPONENT_10':'User is null',
  'PROFILE_COMPONENT_11':'Name incomplete',
  'PROFILE_COMPONENT_12':'E-mail incomplete',
  'PROFILE_COMPONENT_13':'Telephone incomplete',
  'PROFILE_COMPONENT_14':'Date of birth incomplete',
  'PROFILE_COMPONENT_15':'No picture',
  'PROFILE_COMPONENT_16':'No address',
  'PROFILE_COMPONENT_17':"Please type your name.",
  'PROFILE_COMPONENT_18':"Please type your e-mail.",
  'PROFILE_COMPONENT_19':"Profile data saved successfully.",
  'PROFILE_COMPONENT_20':"Let's Go!!",
  'PROFILE_COMPONENT_21':'You are on the event attendee list. When the event starts click on JOIN THE EVENT',

  'GAME_USERLOGIN_COMPONENT_1':'Login with e-mail and password',
  'GAME_USERLOGIN_COMPONENT_2':'Type your e-mail',
  'GAME_USERLOGIN_COMPONENT_3':'Type your password',
  'GAME_USERLOGIN_COMPONENT_4':'I forgot my password',
  'GAME_USERLOGIN_COMPONENT_5':'Keep signed in',
  'GAME_USERLOGIN_COMPONENT_6':'Sign in and enjoy the metaverse',
  'GAME_USERLOGIN_COMPONENT_7':'Type your full name',
  'GAME_USERLOGIN_COMPONENT_8':'Select your avatar',
  'GAME_USERLOGIN_COMPONENT_9':'Repeat passoword',
  'GAME_USERLOGIN_COMPONENT_10':'I have read and agree with Terms and Conditions',
  'GAME_USERLOGIN_COMPONENT_11':"Please fill in your email address so that we can send you a new password request.",
  'GAME_USERLOGIN_COMPONENT_12':"Password reset request sent to your email.",
  'GAME_USERLOGIN_COMPONENT_13':"An error has occurred. Are you sure you signed up? It is worth trying to register with this email.",
  'GAME_USERLOGIN_COMPONENT_14':"Please fill in your name so people can find you on the platform",
  'GAME_USERLOGIN_COMPONENT_15':"Please fill in your email.",
  'GAME_USERLOGIN_COMPONENT_16':"Your password has to have 8 digits.",
  'GAME_USERLOGIN_COMPONENT_17':"Your password has to be confirmed",
  'GAME_USERLOGIN_COMPONENT_18':'Register done',
  'GAME_USERLOGIN_COMPONENT_19':'You are registered. How about you now set your avatar?',
  'GAME_USERLOGIN_COMPONENT_20':"This email is already registered...try again with another email or contact us at contato@liveparty.com.br",
  'GAME_USERLOGIN_COMPONENT_21':"Login successful",
  'GAME_USERLOGIN_COMPONENT_22':"Unidentified error in user registration. Notify us on our insta (@liveparty_br) so that we can help you finalize the login.",
  'GAME_USERLOGIN_COMPONENT_23':"Incorrect password for registered email",
  'GAME_USERLOGIN_COMPONENT_24':"E-mail not found.",
  'GAME_USERLOGIN_COMPONENT_25':"Limit exceeded. Wait a few minutes and try again.",
  'GAME_USERLOGIN_COMPONENT_26':"Terms and conditions of data usage.",

  'APPSCREEN_COMPONENT_1':'Users in the room',
  'APPSCREEN_COMPONENT_2':'Rooms',
  'APPSCREEN_COMPONENT_3':'Contact',
  'APPSCREEN_COMPONENT_4':'Galery',
  'APPSCREEN_COMPONENT_5':'Favorite rooms',
  'APPSCREEN_COMPONENT_6':'Notification',
  'APPSCREEN_COMPONENT_7':'Edit',
  'CONTACT_SCREEN_COMPONENT_1':'Contacts in the room ',
  'CONTACT_SCREEN_COMPONENT_2':'Search contacts',
  'CONTACT_SCREEN_COMPONENT_3':"Videoconference",
  'CONTACT_SCREEN_COMPONENT_4':" Do you wish to invite this user to a videoconference?",
  'CONTACT_SCREEN_COMPONENT_5':'Remove user from the room',
  'CONTACT_SCREEN_COMPONENT_6':'Do you wish to remove ',
  'CONTACT_SCREEN_COMPONENT_7':'Ban user from room',
  'CONTACT_SCREEN_COMPONENT_8':'Do you wish to ban',
  'CONTACT_SCREEN_COMPONENT_9':'? The person will hear a sound to open the platform',
  'CONTACT_SCREEN_COMPONENT_10':'You are not a room admin. Only admins can ban users.',
  'CONTACT_SCREEN_COMPONENT_11':'Do you want to call the attention of',
  'CONTACT_SCREEN_COMPONENT_12':'Call attention',
  'CONTACT_SCREEN_COMPONENT_13':' called your attention.',
  'CONTACT_SCREEN_COMPONENT_14':"TELEPORT",
  'CONTACT_SCREEN_COMPONENT_15':"Do you want to invite this user to teleport to where you are?",
  'CONTACT_SCREEN_COMPONENT_15a':"Do you want to be teleported to the position of this user?",
  'CONTACT_SCREEN_COMPONENT_16':'Invitation sent',
  'CONTACT_SCREEN_COMPONENT_17':' was invited to teleport to where you are. Wait for reply',
  'CONTACT_SCREEN_COMPONENT_18':"Teleport request",
  'CONTACT_SCREEN_COMPONENT_19':" is inviting you to go to the event where you are. Do you want to go?",
  'CONTACT_SCREEN_COMPONENT_20':' was invited to chat with you. Wait for response.',
  'CONTACT_SCREEN_COMPONENT_21':"Video conference request",
  'CONTACT_SCREEN_COMPONENT_22':" is inviting you to go to chat via video conference. Do you accept?",
  'CONTACT_SCREEN_COMPONENT_23':"Removal",
  'CONTACT_SCREEN_COMPONENT_24':' removed you from the room.',
  'CONTACT_SCREEN_COMPONENT_25':"Banishment",
  'CONTACT_SCREEN_COMPONENT_26':" banned you from the room.",

  'FAVORITE_ROOM_SCREEN_1':'Search rooms',
  'FAVORITE_ROOM_SCREEN_2':'Add room',
  'FAVORITE_ROOM_SCREEN_3':'Go to room',
  'FAVORITE_ROOM_SCREEN_4':'Edit room',
  'FAVORITE_ROOM_SCREEN_5':'Remove room',
  'FAVORITE_ROOM_SCREEN_6':'Favorite',
  'FAVORITE_ROOM_SCREEN_7':'This room has already been favorited',
  'FAVORITE_ROOM_SCREEN_8':"In the room",
  'FAVORITE_ROOM_SCREEN_9':"You are already in this room.",
  'FAVORITE_ROOM_SCREEN_10':"Do you wish to teleport to this location?",
  'FAVORITE_ROOM_SCREEN_11':'Removal',
  'FAVORITE_ROOM_SCREEN_12':"You want to remove this room from your favorites list?",
  'FAVORITE_ROOM_SCREEN_13':'Edit room',
  'FAVORITE_ROOM_SCREEN_14':'Describe the name of the room so that it is easy for you to identify it',
  'FAVORITE_ROOM_SCREEN_15': 'Full room',
  'FAVORITE_ROOM_SCREEN_16':"This room has 70 users and is full. Wait for someone to leave so you can enter.",
  'FAVORITE_ROOM_SCREEN_17':"This room has",
  'FAVORITE_ROOM_SCREEN_18':" users of 70. You can enter. ",

  'GALLERY_SCREEN_COMPONENT':'Upload images',

  'PROFILE_SCREEN_1':'Telephone',
  'PROFILE_SCREEN_2':'Birthday',

  'CONTAINER_MODAL_0':'Bag',
  'CONTAINER_MODAL_1':'Hair',
  'CONTAINER_MODAL_2':'Torso',
  'CONTAINER_MODAL_3':'left hand',
  'CONTAINER_MODAL_4':'feet',
  'CONTAINER_MODAL_5':'neck',
  'CONTAINER_MODAL_6':'pernas',
  'CONTAINER_MODAL_7':'right hand',
  'CONTAINER_MODAL_8':'fingers',
  'CONTAINER_MODAL_9':'leg',
  'CONTAINER_MODAL_10':'Equip',
  'CONTAINER_MODAL_11':'Equipping item...wait...',
  'CONTAINER_MODAL_12':'Unequip',
  'CONTAINER_MODAL_13':'Do you want to unequip this item?',
  'CONTAINER_MODAL_14':'empty',
  'CONTAINER_MODAL_15':'Item equipped',
  'CONTAINER_MODAL_16':'Unequip this item to be able to paint',
  'CONTAINER_MODAL_17':'Transfer item',
  'CONTAINER_MODAL_18':'Do you wish to transfer this item to the container?',
  'CONTAINER_MODAL_19':"Item not available",
  'CONTAINER_MODAL_20':" This item, although yours, is not in your backpack. Make sure it hasn't been put on the floor or in a vendor.",
  'CONTAINER_MODAL_21':"Convert Token",
  'CONTAINER_MODAL_22':" You are entitled to an item of this Token. You want to convert the token into an item of type",
  'CONTAINER_MODAL_23':"Manipulate item",
  'CONTAINER_MODAL_24':"This item is not shareable.",
  'CONTAINER_MODAL_25':'Invitation to view object',
  'CONTAINER_MODAL_26':' I would like to share a link with you. Do you accept?',
  'CONTAINER_MODAL_27':"View shared item",
  'CONTAINER_MODAL_28':"Do you want to see the item you just shared?",
  'CONTAINER_MODAL_29':"This item is equipped. Remove it to put it on the ground.",
  'CONTAINER_MODAL_30':"This item is super important!! Don't lose it.",
  'CONTAINER_MODAL_31':"You are in a temporary room and cannot leave your item on the floor.",
  'CONTAINER_MODAL_32':'Drop to floor',
  'CONTAINER_MODAL_33':'You are removing the item to the floor. This item, when placed on the floor, comes out of your wallet and is available for others to see and pick up. Do you confirm that you want to put this item on the floor?',
  'CONTAINER_MODAL_34':"This item is an nft and cannot be removed to the ground",
  'CONTAINER_MODAL_35':'Manipulate key',
  'CONTAINER_MODAL_36':'This key is connected to the code room:',
  'CONTAINER_MODAL_37':"Change name",
  'CONTAINER_MODAL_38':"Enter a name for this key",
  'CONTAINER_MODAL_39':'. What do you wish to do?',
  'CONTAINER_MODAL_40':'Wrong place',
  'CONTAINER_MODAL_41':"This title is not related to this room, so it cannot be used here.",
  'CONTAINER_MODAL_42':'Written object',
  'CONTAINER_MODAL_43':'This object is already written with a link to view an external site. Do you want to open and read the external site or do you want to erase the content and write a new external site?',
  'CONTAINER_MODAL_44':'Read',
  'CONTAINER_MODAL_45':"Write",
  'CONTAINER_MODAL_46':'Equippable item',
  'CONTAINER_MODAL_47':'Do you want to wear this item?',
  'CONTAINER_MODAL_48':'Paint object',
  'CONTAINER_MODAL_49':'Click on the object you want to paint.',
  'CONTAINER_MODAL_50':"Enter a name for this object",
  'CONTAINER_MODAL_51':"Enter the link where to go when clicking on the object",
  'CONTAINER_MODAL_52':'Fill in a valid URL address',
  'CONTAINER_MODAL_53':"Click on item to use or equip",
  'CONTAINER_MODAL_54':"Click on item to transfer to map",
  'CONTAINER_MODAL_55':"Items on the map floor to collect",
  'CONTAINER_MODAL_56':"Write your name",
  'CONTAINER_MODAL_57':"Empty",

  'EVENT_COMPONENT_1a':'Zoom in',
  'EVENT_COMPONENT_2a':'Zoom out',
  'EVENT_COMPONENT_3a':'Tools',
  'EVENT_COMPONENT_4a':'Cellphone',
  'EVENT_COMPONENT_5a':'Audio',
  'EVENT_COMPONENT_6a':'Edit Avatar',
  'EVENT_COMPONENT_7a':'Share',
  'EVENT_COMPONENT_8a':'Notepad',
  'EVENT_COMPONENT_9a':'Leave',
  'EVENT_COMPONENT_10a':'Media/Streamming',
  'EVENT_COMPONENT_11a':'Map',
  'EVENT_COMPONENT_12a':'Online Users',

  'TRANSITION_TITLE':'Transition',
  'TRANSITION_MESSAGE1':"This place has ",
  'TRANSITION_MESSAGE2':"You may enter.",

  'YOUTUBE_COMPONENT_1':"Click and Drag ",
  'YOUTUBE_COMPONENT_2':"(slowlly)",

  'TUTORIAL_COMPONENT_1':"Bem vindo ao metaverso!! Conversas são por audio - autorize uso do microfone.",
  'TUTORIAL_COMPONENT_2':"Headphones são bem vindos. Ajudam você a ouvir os outros",
  'TUTORIAL_COMPONENT_3':"Liveplanet é muito melhor se visto em widescreen.",
  'TUTORIAL_COMPONENT_4':"O cadastro não é obrigatório, mas é indicado para você ter um nome e avatar.",



  'PURCHASE_TERRAIN_MODAL_01': 'Buy Terrain',
  'PURCHASE_TERRAIN_MODAL_02': 'This terrain costs R$',
  'PURCHASE_TERRAIN_MODAL_03': ',00. Click bellow if you want to finish this purchase and obtain this terrain in Liveplanet.',
  'PURCHASE_TERRAIN_MODAL_05': 'You are not logged. Only registered users can purchase terrains',
  'PURCHASE_TERRAIN_MODAL_04': 'Buy',
  'PURCHASE_TERRAIN_MODAL_06': 'Visit here',
  'PURCHASE_TERRAIN_MODAL_07': 'Do you want to visit this terrain?',
  'PURCHASE_TERRAIN_MODAL_09':'Now that you purchased your terrain, it can be found in your bag. You will be sent to your terrain so that you can edit it',
  'PURCHASE_TERRAIN_MODAL_10':'You purchased your terrain, but our network is overloaded. Dont worry! We registered your purchase and you can try again clicking in OBTAIN TERRAIN',

  'DOOR_BEAN_0':'Door',
  'DOOR_BEAN_1':'Full',
  'DOOR_BEAN_2':'This place has ',
  'DOOR_BEAN_3':' users and its full. Wait someone to leave so you can enter.',
  'DOOR_BEAN_4':'lock',
  'DOOR_BEAN_5':'unlock',
  'DOOR_BEAN_6':'Do you wish to use this door?',
  'DOOR_BEAN_7':'Enter',
  'DOOR_BEAN_8':'Leave',
  'DOOR_BEAN_9':'To manipulate this item, you must first position it on the ground of a room',
  'DOOR_BEAN_10':'The door is configured. Do you wish to reconfigure or use it?',
  'DOOR_BEAN_11':'Reconfigure',
  'DOOR_BEAN_12':'The door is not configured. Do you wish to configure or use?',
  'DOOR_BEAN_13':'Configure',
  'DOOR_BEAN_14':'Use',
  'DOOR_BEAN_15':'Which function do you want to apply to this door?',
  'DOOR_BEAN_16':'Other room',
  'DOOR_BEAN_17':'Same room',
  'DOOR_BEAN_18':'Configure door to same room',
  'DOOR_BEAN_19':'Is the door positioned and oriented correctly?',
  'DOOR_BEAN_20':'Wrong configuration',
  'DOOR_BEAN_21':'Position and define orientation of the door before doing this configuration',
  'DOOR_BEAN_30':'Door updated',
  'DOOR_BEAN_31':'Door was updated sucessfully.',
  'DOOR_BEAN_32':'To outside',
  'DOOR_BEAN_33':'Select the room:',
  'DOOR_BEAN_34':'Door locked',
  'DOOR_BEAN_35':'The door is locked and you do not have the key. If you bought a key, checkout where it was bought.',
  'DOOR_BEAN_36':'Door is not configured',
  'DOOR_BEAN_37':'This door is not configured. Configure it before using',

  'USER_INTERACTION_0':'Age',
  'USER_INTERACTION_1':'Bio',
  'USER_INTERACTION_2':'Ask Contact',
  'USER_INTERACTION_3':'Do you wish to ask contact of ',
  'USER_INTERACTION_4':' to add to your contact list? If accepted you will be able to communicate from your cellphone. Do you want to ask?',
  'USER_INTERACTION_5':' asked your contact. Do you accept giving your contact with email access and phone?',


   'ITEM_EDIT_0':'Use',
   'ITEM_EDIT_1':'Collect',
   'ITEM_EDIT_2':'Static',
   'ITEM_EDIT_3':'Spin',
   'ITEM_EDIT_4':'Texture 2D',
   'ITEM_EDIT_5':'Texture 3D',
   'ITEM_EDIT_6':'Actions',
   'ITEM_EDIT_7':'Positioning',
   'ITEM_EDIT_8':'Update Texture',
   'ITEM_EDIT_9':'Erase Texture',
   'ITEM_EDIT_10':'Update Item',
   'ITEM_EDIT_11':'Select action for object',
   'ITEM_EDIT_12':'Define URL of website',
   'ITEM_EDIT_13':'Define video',
   'ITEM_EDIT_14':'Text',
   'ITEM_EDIT_15':'Define audio',
   'ITEM_EDIT_16':'Define image',
   'ITEM_EDIT_17':'Choose NPC',
   'ITEM_EDIT_18':'Edit Avatar',
   'ITEM_EDIT_19':'Choose action that happens close to object',
   'ITEM_EDIT_20':'Define URL of embedded website',
   'ITEM_EDIT_21':'Muted',
   'ITEM_EDIT_22':'Define URL of website exposed when close to object',
   'ITEM_EDIT_23':'Define distance X and Y for activation',
   'ITEM_EDIT_24':'Position data for item',
   'ITEM_EDIT_25':'Name',
   'ITEM_EDIT_26':'Position',
   'ITEM_EDIT_27':'Rotation',
   'ITEM_EDIT_28':'Dimension',
   'ITEM_EDIT_29':'Escale',
   'ITEM_EDIT_30':'Saving texture for item...wait',
   'ITEM_EDIT_31':'Dynamic object',
   'ITEM_EDIT_32':'This object is dynamic and if you statize it, will be stucked on the ground. Do you want to make it static? (you can dynamize using CTRL and click on object)',
   'ITEM_EDIT_33':'Object static',
   'ITEM_EDIT_34':'Object is now locked to the ground. To edit again use CTRL and click on object',
   'ITEM_EDIT_35':'This item cannot be collected',
   'ITEM_EDIT_36':'Only the owner of the item can collect it',
   'ITEM_EDIT_37':'Item collected is now back to your bag',
   'ITEM_EDIT_38':'Wait',
   'ITEM_EDIT_39':'You are removing item to your bag....it takes sometime...',
   'ITEM_EDIT_40':'Item collected is now back to your bag',
   'ITEM_EDIT_41':'An error happened when collecting item and now its back to the original position',
   'ITEM_EDIT_42':'Trello',
   'ITEM_EDIT_43':'Define initial position',
   'ITEM_EDIT_44':'Reset initial position',
   'ITEM_EDIT_45':'Missions',
   'ITEM_EDIT_46':'Select a Mission',
   'ITEM_EDIT_47':'DELETE',

	'CELL_NOTIFY_01':'TEXT',
	'CELL_NOTIFY_02':'VIDEO',
	'CELL_NOTIFY_03':'Create your notification',
	'CELL_NOTIFY_04':'Title',
	'CELL_NOTIFY_05':'VIDEO',
	'CELL_NOTIFY_06':'Send',
	'CELL_NOTIFY_07':'Create notification',


	'EDIT_ROOM_01':'Room Edit',
	'EDIT_ROOM_02':'Room Data',
	'EDIT_ROOM_03':'Name',
	'EDIT_ROOM_04':'Set Initial Position',
	'EDIT_ROOM_05':'Statize Itens',
	'EDIT_ROOM_06':'Dinamize Itens',
	'EDIT_ROOM_07':'Save Room',
	'EDIT_ROOM_08':'Adjust 2D Background',
	'EDIT_ROOM_09':'Choose Image',
	'EDIT_ROOM_10':'Position',
	'EDIT_ROOM_11':'Select',
	'EDIT_ROOM_12':'Save',
	'EDIT_ROOM_13':'Collisions',
	'EDIT_ROOM_14':'Edit',
	'EDIT_ROOM_15':'Save',
	'EDIT_ROOM_16':'Erase',
	'EDIT_ROOM_17':'Create Key',
	'EDIT_ROOM_18':'Make Key',
	'EDIT_ROOM_19':'Company Itens',
	'EDIT_ROOM_20':'Image',
	'EDIT_ROOM_21':'Qtd',
	'EDIT_ROOM_22':'Drop',
	'EDIT_ROOM_23':'Save',
	'EDIT_ROOM_24':'Save',
	'EDIT_ROOM_25':'Save',
	'EDIT_ROOM_26':'Save',


}
public getDefaultLanguage(){
 return this.mylanguage
}
public default;
  constructor( private http: Http) {
    try{
      var userLang = navigator.language || navigator['userLanguage'];
      if (userLang.startsWith("pt")) {
        this.default=this.pt;
      }
      else if (userLang.startsWith("es")){
        this.default=this.es;
      }
      else{
        this.default=this.en;

      }

    }
    catch (err){

    }
  }

  private json;
  ///////////////////YOUTUBE LIVECHAT//////////////////////////
  public setDefaultLang(text:string) {

      try{
        var userLang = navigator.language || navigator['userLanguage'];
        if (text){
          userLang=text
        }
        if (userLang.startsWith("pt")) {
          this.default=this.pt;
        }
        else if (userLang.startsWith("es")){
          this.default=this.es;
        }
        else{
          this.default=this.en;

        }

      }
      catch (err){

      }

  }
  public use(text:string){
   this.mylanguage=text;
  }

  public instant(text: string){
    return this.default[text];
  }
 }




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/services/translation.service.ts